(function(){
  var BRANDS = {
    'motorex': { name: 'Motorex', logo: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorex_logo_500x500_29d7d1cf-7743-4259-b310-2f8e97047076.png', handle: 'motorex' },
    'motul': { name: 'Motul', logo: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motul_logo_500x500_d570e268-a1b5-454c-96f6-03b8981b827a.png', handle: 'motul' },
    'liqui-moly': { name: 'Liqui Moly', logo: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/liqui_moly_logo_500x500_a4210735-b25f-42c5-bd15-a65bc3ad4e9e.png', handle: 'liquid-moly' },
    'maxima': { name: 'Maxima', logo: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Maixma_racing_logo_500x500_c012ce67-1ec4-40e7-98fe-65e0c8cfde09.png', handle: 'maxima-racing' },
    'klotz': { name: 'Klotz', logo: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Klotz_logo_500x500_d45a43db-37aa-44af-aa35-f73ca7476437.png', handle: 'klotz' }
  };
  var BRAND_ORDER = ['motorex', 'motul', 'liqui-moly', 'maxima'];
  var CURRENCY_PREFIX = 'CA$';

  function escHtml(s){
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // Like escHtml, but also escapes double quotes — for values written into
  // a double-quoted HTML attribute (e.g. product data stashed on a
  // data-fby-modal-* attribute for the cross-sell photo-click modal).
  function escAttr(s){
    return escHtml(s).replace(/"/g, '&quot;');
  }

  // Fired after every successful Add to Cart on this page (oil, filter,
  // package, cross-sell, cleaning, and the product-modal size picker all
  // call this). Fetches the authoritative cart totals from Shopify itself
  // — cheaper than threading state through six separate add-to-cart
  // functions — and broadcasts them as a plain window event so the sticky
  // "Your Bike" bar (a separate script/snippet) can show a running total
  // without this file needing to know that bar exists.
  function notifyCartUpdated(){
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        window.dispatchEvent(new CustomEvent('flybyu:cart-updated', {
          detail: { itemCount: cart.item_count, totalPrice: cart.total_price }
        }));
      })
      .catch(function(){});
  }

  // Only these make + brand pairings are genuine OEM factory-fill spec. Every
  // other brand recommendation on this page is Flybyu's own curated pick,
  // based on what we stock and can drop-ship reliably — not a manufacturer
  // OEM claim — and the copy below must say so honestly.
  var OEM_SPEC = {
    'motorex': ['KTM', 'Husqvarna', 'GASGAS', 'GasGas', 'Gas Gas']
  };

  var CURATED_WHY_COPY = {
    'motorex': "Motorex is our top pick for this bike — a high-performance oil well matched to this engine, from the brands we stock and can ship quickly.",
    'motul': "Motul is our top pick for this bike — a trusted, high-performance oil well matched to this engine, from the brands we stock and can ship quickly.",
    'liqui-moly': "Liqui Moly is our top pick for this bike — a German-engineered oil well matched to this engine, from the brands we stock and can ship quickly.",
    'maxima': "Maxima is built and proven for high-performance and off-road engines like this one.",
    'klotz': "Klotz is the go-to for big V-twin cruisers like this, trusted for its high-temp, high-load protection."
  };

  // Alternate-brand "same grade tier" catalog — used only when the shopper
  // clicks an "Also compatible" chip to swap the primary recommendation.
  // These are real, live Shopify products/variants, matched to the SAME
  // grade tier (Full Synthetic / Semi-Synthetic / Mineral) as the bike's
  // own recommendation, but NOT claiming an exact factory-spec viscosity
  // match the way the primary (bike-matched) recommendation does — this is
  // Flybyu's own "same tier, whichever product exists" judgment call, by
  // design (approved 2026-09-10).
  // 2026-09-17: each brand+grade entry now carries every real viscosity
  // variant that product actually stocks (was previously a single
  // hardcoded variant per grade — see pickClosestViscosityVariant below for
  // why that was wrong: a Honda needing 10W-30 swapped to Full Synthetic
  // was always shown Motul 7100's 20W-50 bottle regardless of what the
  // bike actually takes, since 20W-50 was the one variantId hardcoded
  // here). `viscosity` strings and variant ids/prices are the real ones
  // from each product's own Shopify variants (queried 2026-09-17).
  //
  // KNOWN CATALOG DATA ISSUE, flagged to Derek/Nicole, not fixed here:
  // Maxima Pro Plus+ 100% Synthetic Engine Oil's 10W-30 / 1L variant
  // (SKU 3601-0268) is priced at $122.95 in Shopify — that's the 3.79L
  // jug's price, not the 1L bottle's (every other viscosity in this same
  // product is ~$33.95 for 1L). Deliberately left OUT of the variants list
  // below so the closest-viscosity picker can never surface it to a
  // customer; add it back once the 1L price is corrected at the source.
  //
  // FIXED 2026-10-30 (roadmap item: "Investigate the 422 add-to-cart error
  // on a Motorex variant"). Root cause: this table is a point-in-time
  // snapshot of real Shopify variant availability (dated comment above),
  // and nothing re-syncs it against live inventory — unlike the
  // "Complete the job" cross-sell rows, which check stock live. Motorex
  // Four Stroke Oil's 15W-50 / 1L variant (id 48202673291419) sold out in
  // Shopify at some point after this table was built but was never
  // re-flagged here, so any customer who swapped to Motorex + the
  // Semi-Synthetic grade pill on a bike whose own viscosity is closest to
  // 15W-50 (e.g. a 2023 Harley-Davidson Sportster S, KTM 390 Duke, BMW
  // R18, Indian Scout Bobber, several Ducatis — 16 bikes land here) got
  // served that dead variant: it rendered as a normal, clickable Add to
  // Cart button, and Shopify's own `/cart/add.js` correctly 422'd it as
  // sold out — exactly the "pre-existing 422, not caused by our code"
  // symptom flagged twice in collaboration-plan.md on 2026-09-14. Marked
  // `availableForSale: false` below so pickClosestViscosityVariant routes
  // those bikes to the 20W-50 variant instead (closer than 10W-40).
  // Re-verified every other flagged/unflagged variant in this table
  // against live Shopify data while fixing this: also found Klotz's
  // 25W-60 (American V-Twin Techniplate) had drifted the other way —
  // flagged unavailable here since 2026-09-17 but actually restocked
  // (qty 10 live) — corrected back to available so that pill isn't hidden
  // from customers who could actually buy it. Nothing else in this table
  // was stale. This table can go stale again the same way at any time;
  // the durable fix would be a live stock check on these swap variants,
  // same pattern as the cross-sell section — not built here, flagged as
  // a follow-up.
  var ALT_PRODUCTS = {
    'motorex': {
      'Full Synthetic': { title: 'Motorex Top Speed 4T', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorex_Top_Speed_1L_5W40.png?v=1774969790', bottleSizeL: 1.0, handle: 'motorex-top-speed-4t', variants: [
        { viscosity: '5W-40', variantId: '48207577907355', price: '32.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorex_Top_Speed_1L_5W40.png?v=1774969790' },
        { viscosity: '10W-30', variantId: '48207577940123', price: '31.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorex_Top_Speed_1L_10W30.png?v=1774971157' },
        { viscosity: '10W-40', variantId: '48207577972891', price: '32.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorex_Top_Speed_1L_10W40.png?v=1774971480' },
        { viscosity: '15W-50', variantId: '48207578005659', price: '33.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorex_Top_Speed_1L_15W50.png?v=1774971574' }
      ] },
      'Semi-Synthetic': { title: 'Motorex Four Stroke Oil', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorex_four_stroke_10w40.png?v=1774913847', bottleSizeL: 1.0, handle: 'motorex-four-stroke-oil', variants: [
        { viscosity: '10W-40', variantId: '48202673258651', price: '21.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorex_four_stroke_10w40.png?v=1774913847' },
        { viscosity: '15W-50', variantId: '48202673291419', price: '21.95', availableForSale: false, image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorex_four_stroke_15w50.png?v=1774914030' },
        { viscosity: '20W-50', variantId: '48202673324187', price: '21.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorex_four_stroke_20w50.png?v=1774914166' }
      ] }
    },
    'motul': {
      'Full Synthetic': { title: 'Motul 7100 Full Synthetic Ester Motor Oil', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/7100_5w40.webp?v=1773274355', bottleSizeL: 1.0, handle: '7100-full-synthetic-ester-motor-oil', variants: [
        { viscosity: '5W-40', variantId: '45788051275931', price: '39.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/7100_5w40.webp?v=1773274355' },
        { viscosity: '10W-40', variantId: '45788051341467', price: '39.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/7100_10W40_1L.webp?v=1773274355' },
        { viscosity: '10W-50', variantId: '45788051439771', price: '39.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/7100_10W50_1L.webp?v=1773274355' },
        { viscosity: '10W-60', variantId: '45788051505307', price: '39.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/7100_10W60_1L.webp?v=1773274355' },
        { viscosity: '15W-50', variantId: '45788051570843', price: '39.95', availableForSale: false, image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/7100_15W50_1L.webp?v=1773274355' },
        { viscosity: '20W-50', variantId: '45788051636379', price: '39.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/7100_20w50_1l.webp?v=1773274355' }
      ] },
      'Mineral': { title: 'Motul 3000 4T Mineral Motor Oil', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/3000_10W40_1L.webp?v=1733363645', bottleSizeL: 1.0, handle: '3000-4t-mineral-motor-oil', variants: [
        { viscosity: '10W-40', variantId: '45836722372763', price: '26.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/3000_10W40_1L.webp?v=1733363645' },
        { viscosity: '20W-50', variantId: '45836722471067', price: '27.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/3000_20w50_1L.webp?v=1733364058' }
      ] }
    },
    'liqui-moly': {
      'Full Synthetic': { title: 'Liqui Moly 10W40 Full Synthetic Street Motor Oil', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/10W40_street_1L.png?v=1773271353', bottleSizeL: 1.0, handle: '10w40-full-synthetic-street-motor-oil', variants: [
        { viscosity: '10W-40', variantId: '45986154872987', price: '26.95' }
      ] },
      'Mineral': { title: 'Liqui Moly 10W40 Mineral Street Motor Oil', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/10W40_mineral_street_1L.png?v=1773418287', bottleSizeL: 1.0, handle: '10w40-mineral-street-motor-oil', variants: [
        { viscosity: '10W-40', variantId: '45987492561051', price: '21.95' }
      ] }
    },
    'maxima': {
      'Full Synthetic': { title: 'Maxima Pro Plus+ 100% Synthetic Engine Oil', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/PROPLUS_100_SYNTHETICENGINEOIL.png?v=1771449510', bottleSizeL: 1.0, handle: 'pro-plus-100-synthetic-engine-oil', variants: [
        { viscosity: '10W-40', variantId: '48028773286043', price: '33.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/PRO_PLUS_100_SYNTHETIC_ENGINE_OIL_10WS-10_1L.png?v=1771602002' },
        { viscosity: '10W-50', variantId: '48028773318811', price: '33.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/PRO_PLUS_100_SYNTHETIC_ENGINE_OIL_10W-50_1L.png?v=1771602107' },
        { viscosity: '20W-50', variantId: '48028773351579', price: '33.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/PRO_PLUS_100_SYNTHETIC_ENGINE_OIL_20W_50_1L.png?v=1771602240' }
      ] },
      'Semi-Synthetic': { title: 'Maxima Syn Blend 4', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/SYNBLEND4.webp?v=1771453211', bottleSizeL: 1.0, handle: 'syn-blend-4', variants: [
        { viscosity: '10W-30', variantId: '48028969042075', price: '23.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/SYN_BLEND_4_10W_30_1L.png?v=1771603104' },
        { viscosity: '10W-40', variantId: '48028969107611', price: '23.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/SYN_BLEND_4_10W_40_1L.png?v=1771603317' },
        { viscosity: '15W-50', variantId: '48028969173147', price: '23.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/SYN_BLEND_4_15W_50_1L.png?v=1771603393' },
        { viscosity: '20W-50', variantId: '48028969238683', price: '23.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/SYN_BLEND_4_20W_50_1L.png?v=1771603503' }
      ] },
      'Mineral': { title: 'Maxima Premium 4 Oil', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/PREMIUM4OIL.png?v=1771451121', bottleSizeL: 1.0, handle: 'premium-4-oil', variants: [
        { viscosity: '5W-30', variantId: '48028956786843', price: '18.95', availableForSale: false, image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/PREMIUM_4_OIL_5W_30_1L.png?v=1771602795' },
        { viscosity: '10W-30', variantId: '48028888531099', price: '20.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/PREMIUM_4_OIL_10W_30_1L.png?v=1771602833' },
        { viscosity: '10W-40', variantId: '48028888563867', price: '20.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/PREMIUM_4_OIL_10W_40_1L.png?v=1771602916' },
        { viscosity: '20W-50', variantId: '48028888596635', price: '20.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/PREMIUM_4_OIL_20W_50_1L.png?v=1771602998' }
      ] }
    },
    'klotz': {
      // Handle corrected 2026-09-17 (drive-by fix): the real Shopify handle
      // carries the registered-trademark "®" in "Techniplate®" — the old
      // hardcoded handle here was missing it, so the "View full product
      // page" link and description fetch for this product were both
      // silently pointing at a handle that doesn't exist.
      'Full Synthetic': { title: 'Klotz American V-Twin Techniplate Lubricant', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/AMERV-TWINSYN10W40.946L.png?v=1773700855', bottleSizeL: 0.946, handle: 'american-v-twin-techniplate®-lubricant', variants: [
        { viscosity: '10W-40', variantId: '48141179093147', price: '28.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/AMER_V-TWIN_SYN_10W40_.946_L.png?v=1773701107' },
        { viscosity: '20W-50', variantId: '48141179125915', price: '26.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/AMER_V-TWIN_SYN_20W50_.946_L.png?v=1773701038' },
        { viscosity: '25W-60', variantId: '48141179158683', price: '27.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/AMER_V-TWIN_SYN_25W60_.946_L.png?v=1773701089' }
      ] }
    }
  };
  var GRADE_FALLBACK_ORDER = ['Full Synthetic', 'Semi-Synthetic', 'Mineral'];

  // Parses a viscosity spec like "SAE 10W-30 (JASO MA2)" or a bare
  // "10W-40" into {cold, hot} numbers, or null if nothing matches.
  function parseViscosity(str){
    var m = (str || '').match(/(\d{1,2})\s*W\s*-?\s*(\d{2})/i);
    if (!m) return null;
    return { cold: parseInt(m[1], 10), hot: parseInt(m[2], 10) };
  }

  // How "far" one viscosity is from another. Cold (winter) rating is
  // weighted 3x hot rating — matching a bike's cold-start rating (e.g.
  // staying on "10W-something") matters more than an exact match on the
  // hot number, and this ordering is what makes a 10W-30 bike land on a
  // 10W-40 alternate rather than a same-hot-number-but-different-cold one.
  function viscosityDistance(a, b){
    return 3 * Math.abs(a.cold - b.cold) + Math.abs(a.hot - b.hot);
  }

  // Given a grade entry's real `variants` list and the bike's own actual
  // viscosity spec (bike.viscosity, e.g. "SAE 10W-30 (JASO MA2)"), picks
  // the closest-available real variant — added 2026-09-17 after Derek
  // caught Honda 10W-30 bikes being shown a hardcoded Motul 7100 20W-50
  // bottle on Full Synthetic when 7100 also comes in 10W-40, which is
  // obviously the closer/correct pick. Prefers in-stock variants; only
  // falls back to an out-of-stock one if every variant for that product is
  // unavailable. Falls back to the first variant if the bike's own
  // viscosity can't be parsed (shouldn't happen for any real 4-stroke bike
  // — see isTwoStrokeBike/oilNotApplicable, which route around this path
  // entirely).
  function pickClosestViscosityVariant(variants, targetViscosityStr){
    if (!variants || !variants.length) return null;
    var inStock = variants.filter(function(v){ return v.availableForSale !== false; });
    var pool = inStock.length ? inStock : variants;
    var target = parseViscosity(targetViscosityStr);
    if (!target) return pool[0];
    var best = null, bestDist = null;
    for (var i = 0; i < pool.length; i++){
      var v = pool[i];
      var parsed = parseViscosity(v.viscosity);
      var d = parsed ? viscosityDistance(target, parsed) : Infinity;
      if (best === null || d < bestDist){ best = v; bestDist = d; }
    }
    return best;
  }

  // "10W-40 / 1L" for a clean-liter bottle size, or just "10W-40" when the
  // real bottle size isn't a round number of liters (e.g. Klotz's 946ml) —
  // matches how these were written by hand before this catalog carried
  // real per-viscosity variants.
  function formatViscosityVariantTitle(viscosity, bottleSizeL){
    if (bottleSizeL && Math.abs(bottleSizeL - Math.round(bottleSizeL)) < 0.001){
      return viscosity + ' / ' + Math.round(bottleSizeL) + 'L';
    }
    return viscosity;
  }

  // Alternate-brand catalog for TWO-STROKE bikes (added 2026-09-15, fixing a
  // real bug Derek found: swapping brands on a 2-stroke bike, e.g. Beta 300
  // RR Motul → Motorex, was pulling from the 4-stroke ALT_PRODUCTS table
  // above and showing a 10W-40 4-stroke oil instead of a 2-stroke one).
  // Same "same grade tier, real in-stock product, not necessarily an exact
  // spec match" judgment call as ALT_PRODUCTS — sourced from the live
  // catalog, one real 2-stroke product per brand per grade actually carried:
  //  - Motorex: only carries one 2-stroke oil (Cross Power 2T Synthetic,
  //    genuinely "Fully synthetic... for 2-stroke Off-Road motorcycles" per
  //    its own product description).
  //  - Motul: 710 (Full Synthetic) and 510 (Semi-Synthetic) — both tagged
  //    for both on-road and off-road use (MCS 2SEO + MCD 2SEO), so no
  //    road/off-road split needed here.
  //  - Klotz: Techniplate Synthetic 2-Stroke Oil — confirmed "100% Full
  //    Synthetic" and explicitly recommended for Beta/KTM/Husqvarna/etc.
  //    off-road models in its own spec sheet.
  //  - Maxima: only carries Semi-Synthetic 2-stroke oils (confirmed via
  //    product description) — no Full Synthetic 2T product in the catalog,
  //    so a Full-Synthetic-spec bike falls back to Semi-Synthetic here via
  //    GRADE_FALLBACK_ORDER, same honest fallback behavior as the 4-stroke
  //    table already uses.
  var ALT_PRODUCTS_2STROKE = {
    'motorex': {
      'Full Synthetic': { title: 'Motorex Cross Power 2T Synthetic', variantTitle: '1L', variantId: '48214501163163', price: '40.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorex_Cross_Power_2T_1l.png?v=1775001753', bottleSizeL: 1.0, handle: 'motorex-cross-power-2t-synthetic' }
    },
    'motul': {
      'Full Synthetic': { title: 'Motul 710 Full Synthetic Two-Stroke Motor Oil', variantTitle: '1L', variantId: '45963299291291', price: '48.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motul_710_1l.png?v=1773846249', bottleSizeL: 1.0, handle: '710-full-synthetic-two-stroke-motor-oil' },
      'Semi-Synthetic': { title: 'Motul 510 Semi Synthetic Two-Stroke Motor Oil', variantTitle: '1L', variantId: '45963484102811', price: '34.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motul_510_1l.png?v=1773845609', bottleSizeL: 1.0, handle: '510-semi-synthetic-two-stroke-motor-oil' }
    },
    'liqui-moly': {
      'Full Synthetic': { title: 'Liqui Moly 2-Stroke Off-Road Full Synthetic Race Motor Oil', variantTitle: '1L', variantId: '45987577561243', price: '32.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/2T_offroad_race_1L.png?v=1773409871', bottleSizeL: 1.0, handle: '2-stroke-off-road-full-synthetic-race-motor-oil' },
      'Semi-Synthetic': { title: 'Liqui Moly 2-Stroke Off-Road Semi Synthetic Motor Oil', variantTitle: '1L', variantId: '45987569238171', price: '18.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/offroad_2T_1L.png?v=1773407968', bottleSizeL: 1.0, handle: '2-stroke-off-road-semi-synthetic-motor-oil' }
    },
    'maxima': {
      'Semi-Synthetic': { title: 'Maxima Premium 2 2-Cycle Oil', variantTitle: 'Default', variantId: '48028990374043', price: '35.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/PREMIUM22-CYCLEOIL.webp?v=1771453631', bottleSizeL: 1.0, handle: 'premium-2-2-cycle-oil' }
    },
    'klotz': {
      'Full Synthetic': { title: 'Klotz Techniplate® Synthetic 2-Stroke Oil', variantTitle: '943ml', variantId: '48153282314395', price: '24.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/MOTOTECHTC-W2.946L.png?v=1773949264', bottleSizeL: 0.943, handle: 'techniplate®-synthetic-2-stroke-oil' }
    }
  };

  // ---- "Complete the job" brand-based cross-sell (2026-09-14) ----
  // Real, live Shopify products for the categories most bikes need beyond
  // oil + filter: brake/clutch fluid, transmission/gear oil, and chain
  // care. Shown first for the bike's own primary brand (matching what the
  // customer already picked for their oil), with an "other brands" expand
  // for anyone who wants a different one — same "curated, real product,
  // not necessarily an exact-spec match" judgment call as ALT_PRODUCTS
  // above. Klotz and Liqui Moly don't carry a brake fluid product in the
  // catalog today — that's a genuine catalog gap, not an oversight, so
  // there's deliberately no 'klotz' / 'liqui-moly' entry under 'brake'.
  var CROSS_SELL_LABELS = {
    brake: 'Brake & Clutch Fluid',
    trans: 'Transmission / Gear Oil',
    primary: 'Primary Oil',
    fork: 'Fork Oil',
    coolant: 'Coolant',
    chain: 'Chain Care',
    shaft: 'Shaft Drive Oil'
  };
  // brake/trans render through the generic brand-table path below; primary,
  // fork, and the drive-system-aware chain/shaft card each have bespoke
  // gating (see renderPrimaryOilCard / renderForkOilCard /
  // renderDriveSystemCard) so they're handled separately in renderCrossSell,
  // not in this loop.
  var CROSS_SELL_ORDER = ['brake', 'trans'];
  var CROSS_SELL_BRAND_ORDER = ['motorex', 'motul', 'maxima', 'klotz', 'liqui-moly'];
  var CROSS_SELL_PRODUCTS = {
    brake: {
      'motorex': { title: 'Motorex DOT-5.1 Brake Fluid', variantId: '48236995117211', price: '26.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorex5.1brakefluid.png?v=1775091387', handle: 'motorex-dot-5-1-brake-fluid' },
      'motul': { title: 'Motul DOT 3 & 4 Brake Fluid', variantId: '45974578069659', price: '28.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motuldot4500x500.png?v=1743467530', handle: 'dot-3-4-brake-fluid' },
      'maxima': { title: 'Maxima DOT 4 Brake Fluid', variantId: '48062214996123', price: '13.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/DOT4BRAKEFLUID.png?v=1772057141', handle: 'dot-4-brake-fluid' }
    },
    trans: {
      'motorex': { title: 'Motorex Moto Gear Oil 10W30', variantId: '48223119442075', price: '29.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/motorexgearoil10W30.png?v=1775059432', handle: 'motorex-moto-gear-oil-10w30' },
      'motul': { title: 'Motul Transoil Expert 10W40 Semi-Synthetic', variantId: '45966382956699', price: '29.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motultransoil10w40.png?v=1773844453', handle: 'transoil-expert-10w40-semi-synthetic' },
      'maxima': { title: 'Maxima MTL 2/4-Stroke Transmission Fluid', variantId: '48056346902683', price: '20.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/MTL2-AND4-CYCLETRANSMISSIONFLUID10W30.png?v=1771967388', handle: 'mtl-2-and-4-cycle-transmission-fluid' },
      'klotz': { title: 'Klotz Techniplate® Hypoid Transmission Lubricant (Big Twin)', variantId: '48141104873627', price: '30.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/TECHNIPLATE_HYPOIDTRANSMISSIONLUBRICANTFORBIGTWIN.png?v=1773696108', handle: 'techniplate-hypoid-transmission-lubricant-for-big-twin' },
      'liqui-moly': { title: 'Liqui Moly Gear Oil Full Synthetic 75W90', variantId: '45988571021467', price: '38.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/gearoil75w90.png?v=1737295454', handle: 'gear-oil-75w90' }
    },
    chain: {
      // Chain LUBRICANT, one real product per brand. Motul's and Maxima's
      // previous entries here were their bundled "chain care kits"
      // ($72.95 / $63.95) — now that we show a standalone cleaner alongside
      // this (see CHAIN_CLEANER_PRODUCTS below), we switched those two to
      // their standalone lube SKUs so every brand's pairing is "cleaner +
      // lube" at a consistent, comparable price, not "kit + lube" for two
      // of five brands. The kits are still live in the catalog if Derek
      // wants them referenced elsewhere.
      //
      // On/off-road split added 2026-09-15 (fixing a bug Derek found: an
      // off-road bike was being shown a "Road Chain Lube"). Only Motorex
      // and Motul carry genuinely separate road vs. off-road chain lube
      // SKUs in the catalog today — Maxima/Klotz/Liqui Moly each carry one
      // general-purpose chain lube (not labeled road or off-road), so
      // those three stay a single product for both bike types; see
      // resolveChainLube() below for how this gets picked per bike.
      'motorex': {
        onRoad: { title: 'Motorex Road Chain Lube', variantId: '48240677421211', price: '23.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorexroadchainlube.png?v=1775143589', handle: 'motorex-road-chain-lube' },
        offRoad: { title: 'Motorex Off-road Chain Lube', variantId: '48241062412443', price: '23.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorexoff-roadchainlube.png?v=1775145186', handle: 'motorex-off-road-chain-lube' }
      },
      'motul': {
        onRoad: { title: 'Motul Road Chain Lube', variantId: '45978417430683', price: '22.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motulchainroad500x500_55b24663-0833-4bd3-806a-412135ca8b16.png?v=1743467028', handle: 'road-chain-lube' },
        offRoad: { title: 'Motul Off-Road Chain Lube', variantId: '45978432798875', price: '23.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motulchainoff-road500x500.png?v=1743466792', handle: 'off-road-chain-lube-1' }
      },
      'maxima': { title: 'Maxima 100% Synthetic Chain Guard', variantId: '48062236360859', price: '26.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/chsin.png?v=1773855803', handle: '100-synthetic-chain-guard' },
      'klotz': { title: 'Klotz Chain Lube', variantId: '48141128663195', price: '19.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/CHAINLUBE15.5oz.png?v=1773697808', handle: 'chain-lube-1' },
      'liqui-moly': { title: 'Liqui Moly Chain Lube', variantId: '45989160616091', price: '29.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/chainlube.jpg?v=1737316348', handle: 'chain-lube' }
    }
  };

  // Picks the right chain lube entry for a brand + this bike's on/off-road
  // spec (the bike record's existing `onOffRoad` field — no new sheet
  // column needed, Nicole's data already has this). Brands with a single
  // general-purpose lube (no onRoad/offRoad split) just return that product
  // unchanged for either road type.
  function resolveChainLube(brandSlug, isOffRoad){
    var entry = CROSS_SELL_PRODUCTS.chain[brandSlug];
    if (!entry) return null;
    if (entry.onRoad || entry.offRoad){
      return (isOffRoad ? entry.offRoad : entry.onRoad) || entry.offRoad || entry.onRoad;
    }
    return entry;
  }

  function isOffRoadBike(bike){
    return /^off/i.test(String((bike && bike.onOffRoad) || '').trim());
  }

  // Chain CLEANER, one real product per brand where the catalog has one.
  // Klotz and Liqui Moly don't carry a chain cleaner today — a genuine
  // catalog gap — so for those two we pair their lube with Muc-Off's
  // cleaner instead of showing nothing: Muc-Off is this shop's own
  // cleaning-and-maintenance-focused brand (see the project brief), so
  // it's a natural fit, not a random substitution. brandOverride makes
  // the row show "Muc-Off" rather than the (wrong) primary brand name.
  var CHAIN_CLEANER_PRODUCTS = {
    'motorex': { title: 'Motorex Chain Clean Degreaser', variantId: '48240994484379', price: '23.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorexchainclean.png?v=1775144879', handle: 'motorex-chain-clean-degreaser' },
    'motul': { title: 'Motul Chain Clean', variantId: '45978453639323', price: '21.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motulchainclean500x500.png?v=1743465075', handle: 'chain-clean' },
    'maxima': { title: 'Maxima Cleanup Chain Cleaner', variantId: '48062251499675', price: '22.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/up.png?v=1773856971', handle: 'cleanup-chain-cleaner' },
    'klotz': { title: 'Muc-Off Chain Cleaner', variantId: '45734979731611', price: '26.99', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/chaincleaner.webp?v=1730909078', handle: 'chain-cleaner', brandOverride: 'Muc-Off' },
    'liqui-moly': { title: 'Muc-Off Chain Cleaner', variantId: '45734979731611', price: '26.99', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/chaincleaner.webp?v=1730909078', handle: 'chain-cleaner', brandOverride: 'Muc-Off' }
  };

  // Coolant, one real product per brand where the catalog has one (added
  // 2026-09-15 per Derek). Only Motorex and Maxima carry a genuine coolant
  // product today — Motul, Klotz, and Liqui Moly have no coolant in the
  // catalog (Liqui Moly's "Motorbike Radiator Cleaner" is a flush product,
  // not a coolant, so it isn't used here) — a real catalog gap, not a bug.
  // Maxima's "Off-Road Coolant" (ethylene glycol, real freeze protection)
  // was picked over their "Cool-Aide" racing coolant, which explicitly
  // offers no freeze protection — the wrong choice for a Canadian shop.
  var COOLANT_PRODUCTS = {
    'motorex': { title: 'Motorex Coolant 3.0 (Ready to Use)', variantId: '48243081445531', price: '25.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorex_M3.0_coolant_1L.png?v=1775153954', handle: 'motorex-coolant-3-0-ready-to-use' },
    'maxima': { title: 'Maxima Off-Road Coolant', variantId: '48081901650075', price: '24.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/OFF-ROADCOOLANT.png?v=1772500776', handle: 'off-road-coolant' }
  };

  // A bike is liquid-cooled if Nicole's coolingSystemCapacityL field isn't
  // her "not applicable" marker (isNA covers both "N/A" and the explicit
  // "N/A (air-cooled)" label she uses for air-cooled bikes). "Unknown" (a
  // couple of bikes where it's liquid-cooled but the exact capacity hasn't
  // been researched yet) still counts as applicable — the coolant product
  // is still real, we just can't show a capacity number for it.
  function isLiquidCooledBike(bike){
    return !isNA(bike && bike.coolingSystemCapacityL);
  }

  // Shared, strict capacity-value parser used by every "your bike takes
  // about X L of ___" note (coolant, transmission, primary/chaincase oil,
  // shaft drive oil). Requires the whole trimmed string to be a plain
  // decimal number — not just parseFloat, which would happily read "75W-90"
  // as 75 and show a false "75L" quantity. This exact bad data exists today
  // (one Triumph's shaftDriveCapacityL column has "75W-90" copy-pasted into
  // it instead of a real liter value, flagged to Derek/Nicole separately) —
  // this guard means a sheet mistake like that silently omits the note
  // instead of showing something absurd.
  function parseCapacityLiters(v){
    if (isNA(v)) return null;
    var s = String(v).trim();
    if (!/^\d+(\.\d+)?$/.test(s)) return null;
    var n = parseFloat(s);
    return isFinite(n) ? n : null;
  }

  function coolantCapacityLiters(bike){
    return parseCapacityLiters(bike && bike.coolingSystemCapacityL);
  }

  // Builds a "Your bike takes about X L of <label>" note element, or
  // returns null when the sheet value isn't a clean number (see
  // parseCapacityLiters). Shared by the transmission, coolant, primary
  // (chaincase), and shaft-drive capacity notes so they all get the same
  // bad-data guard and the same copy pattern.
  function capacityNoteEl(label, rawValue){
    var litres = parseCapacityLiters(rawValue);
    if (litres === null) return null;
    var el = document.createElement('div');
    el.className = 'fby-crosssell-capacity-note';
    el.textContent = 'Your bike takes about ' + litres + 'L of ' + label + '.';
    return el;
  }

  // Shaft drive: the catalog carries exactly one purpose-built shaft/final-
  // drive gear oil (Maxima), with no per-weight or per-brand variants.
  // Shown for every shaft-drive bike regardless of primary brand until real
  // Motul/Liqui Moly shaft-drive oils exist — flagged to Derek separately.
  var SHAFT_DRIVE_OIL_PRODUCT = { title: 'Maxima Shaft Drive Gear Oil', variantId: '48056451924123', price: '33.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/SHAFTDRIVEGEAROIL.png?v=1771969799', handle: 'shaft-drive-gear-oil' };

  // ---- Motul "TWIN" line: purpose-built for HD Big Twin / Sportster engines ----
  // (2026-09-14 round). TWIN_ENGINE_OIL_HANDLE doubles as the marker we use
  // elsewhere to know a given bike record was switched onto the TWIN line
  // (see transTableForBike) — no separate boolean field needed on the bike data.
  var TWIN_ENGINE_OIL_HANDLE = 'twin-motor-oil-20w50-full-synthetic';
  var TWIN_PRIMARY_OIL_PRODUCT = { title: 'Motul TWIN Primary Oil', variantId: '45972923220123', price: '32.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/TWINprimary.webp?v=1736901962', handle: 'twin-primary-oil' };
  var TWIN_GEAR_OIL_PRODUCT = { title: 'Motul TWIN Gear 75W90 Transmission Oil', variantId: '45972957429915', price: '45.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/TWINgear75W90.webp?v=1736902459', handle: 'twin-gear-75w90-transmission-oil' };
  // Added 2026-09-16: a real Maxima equivalent for the Primary Oil card, so
  // it isn't a dead end when the Motul TWIN product is out of stock (it was,
  // on a real customer's bike, the day this was added — see
  // renderPrimaryOilCard below). SKU 3603-0043, confirmed in the catalog by Derek.
  var MAXIMA_PRIMARY_OIL_PRODUCT = { title: 'Maxima V-Twin Synthetic Primary Oil', variantId: '48062061445275', price: '28.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/V-TWINSYNTHETICPRIMARYOIL.png?v=1772053946', handle: 'v-twin-synthetic-primary-oil' };

  // ---- Fork oil: brand + exact-weight matched (2026-09-14 round) ----
  // Only exact weight matches are listed on purpose — no "nearest available"
  // fallback — so we never present a wrong-viscosity fork oil as correct.
  // Gaps (a brand with no product at a bike's weight) are just omitted from
  // the table and the "show other brands" toggle covers the rest.
  var FORK_OIL_PRODUCTS = {
    'motorex': {
      '4W': { title: 'Motorex Racing Fork Oil 4W', variantId: '48235203526811', price: '36.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorex_2.5W_fork_oil.png?v=1775076322', handle: 'motorex-racing-fork-oil-2-5w-4w-5w-7-5w-10w-15w' },
      '5W': { title: 'Motorex Racing Fork Oil 5W', variantId: '48235203559579', price: '36.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorex_2.5W_fork_oil.png?v=1775076322', handle: 'motorex-racing-fork-oil-2-5w-4w-5w-7-5w-10w-15w' },
      '10W': { title: 'Motorex Racing Fork Oil 10W', variantId: '48235203625115', price: '36.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motorex_2.5W_fork_oil.png?v=1775076322', handle: 'motorex-racing-fork-oil-2-5w-4w-5w-7-5w-10w-15w' }
    },
    'motul': {
      '5W': { title: 'Motul Expert Fork Oil 5W', variantId: '45974560931995', price: '31.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motul_fork_oil_5w.png?v=1773841165', handle: 'expert-fork-oil' },
      // Motul's "Expert" fork oil line has no 7.5W, and its 10W variant is
      // out of stock — so both 7.5W and 10W here come from the "Factory
      // Line Racing" range instead (different sub-line, higher price point;
      // the 7.5W variant is itself currently out of stock too — flagged).
      '7.5W': { title: 'Motul Factory Line Fork Oil Racing 7.5W', variantId: '45974567256219', price: '33.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motul_Fork_Oil_2.5W_1000x1000_144701c0-baaa-45d9-8eb4-00d99064fbd4.png?v=1743468132', handle: 'factory-line-fork-oil-racing' },
      '10W': { title: 'Motul Factory Line Fork Oil Racing 10W', variantId: '45974567288987', price: '46.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/Motul_Fork_Oil_2.5W_1000x1000_144701c0-baaa-45d9-8eb4-00d99064fbd4.png?v=1743468132', handle: 'factory-line-fork-oil-racing' }
    },
    'liqui-moly': {
      '5W': { title: 'Liqui Moly Fork Oil 5W Light', variantId: '45989247484059', price: '41.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/forkoil5W.png?v=1737319043', handle: 'fork-oil-5w' },
      '7.5W': { title: 'Liqui Moly Fork Oil 7.5W Medium/Light', variantId: '45989251317915', price: '39.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/forkoil7.5W.jpg?v=1737319227', handle: 'fork-oil-7-5w-medium-light' },
      '10W': { title: 'Liqui Moly Fork Oil 10W Medium', variantId: '45989256298651', price: '38.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/forkoil10W.png?v=1737319479', handle: 'fork-oil-10w-medium' }
    },
    'klotz': {
      '10W': { title: 'Klotz Racing Synthetic Fork Fluid 10WT', variantId: '48153763152027', price: '24.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/SYNRACINGFORKSHOCK5W.946L.png?v=1773951373', handle: 'racing-synthetic-fork-and-shock-fluid' }
    },
    'maxima': {
      '5W': { title: 'Maxima Fork Oil 5W', variantId: '48062104436891', price: '22.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/54916-55W1L.png?v=1772055036', handle: 'fork-oil' },
      '10W': { title: 'Maxima V-Twin Fork Oil 10W', variantId: '48062153130139', price: '22.95', image: 'https://cdn.shopify.com/s/files/1/0663/0241/0907/files/V-TWINFORKOIL10W.png?v=1772056049', handle: 'v-twin-fork-oil' }
    }
  };

  function crossSellBrandName(slug){
    return (BRANDS[slug] && BRANDS[slug].name) || slug;
  }

  function isOemMatch(brandSlug, make){
    var makes = OEM_SPEC[brandSlug];
    if (!makes) return false;
    return makes.some(function(m){ return m.toLowerCase() === (make || '').toLowerCase(); });
  }

  function getWhyCopy(bike, brandSlug, brandName){
    if (isOemMatch(brandSlug, bike.make)){
      return brandName + ' is ' + bike.make + '’s factory-fill oil, formulated to the exact OEM spec for this engine. It’s what your bike left the factory with.';
    }
    return CURATED_WHY_COPY[brandSlug] ||
      (brandName + ' is our recommended oil for this engine, based on our shop’s fitment data.');
  }

  function normalizeGrade(g){
    var t = (g || '').trim();
    if (/^semi[\s-]?synthetic$/i.test(t)) return 'Semi-Synthetic';
    if (/^full[\s-]?synthetic$/i.test(t)) return 'Full Synthetic';
    if (/^mineral$/i.test(t)) return 'Mineral';
    if (/^racing$/i.test(t)) return 'Racing';
    return t || 'Full Synthetic';
  }

  function extractViscosity(text){
    var m = (text || '').match(/\d+W-\d+/i);
    return m ? m[0] : null;
  }

  function isNA(v){
    return v === null || v === undefined || v === '' || /^n\/a\b/i.test(String(v).trim());
  }

  // Two-stroke premix support (added 2026-09-15 for Nicole's new "Mix
  // Ratio" column). A bike is treated as two-stroke purely by whether it
  // has a real, parseable mix ratio (e.g. "60:1") rather than by matching
  // engineType text — that's the actual signal driving this display, and
  // it fails safe: a 2-stroke bike with no ratio filled in yet just falls
  // back to the normal engine-oil capacity copy below.
  function parseMixRatio(v){
    if (isNA(v)) return null;
    var m = String(v).trim().match(/^(\d+(?:\.\d+)?)\s*:\s*1$/);
    return m ? parseFloat(m[1]) : null;
  }

  function isTwoStrokeBike(bike){
    return !!(bike && parseMixRatio(bike.mixRatio));
  }

  // How much premix oil a 20L fuel can needs at this bike's ratio — 20L is
  // the most common dirt-bike jerry-can size (per Derek).
  function mixOilMlFor20L(ratioNum){
    return Math.round(20000 / ratioNum);
  }

  // A grade entry is either the new 2026-09-17 schema (a `variants` list of
  // real per-viscosity SKUs, resolved here against the bike's own actual
  // viscosity) or the older flat schema still used by ALT_PRODUCTS_2STROKE
  // (already a single complete product — 2-stroke oils aren't sold by SAE
  // viscosity grade, so there's nothing to pick between).
  //
  // 2026-09-17 (later same day): each variant now carries its own real
  // Shopify-assigned photo (queried directly from each product's variants —
  // Nicole had already uploaded a distinct label photo per viscosity for
  // every multi-viscosity product in this catalog). Derek noticed the photo
  // wasn't updating when the viscosity swapped (e.g. Motul staying on its
  // 5W-40-labeled bottle after landing on the real 10W-40 variant) — the
  // title/price/variantId were already following `chosen`, just not the
  // photo. `chosen.image` is preferred now; `entry.image` is kept only as a
  // fallback for the couple of genuinely single-viscosity products (Liqui
  // Moly's two) whose one real variant has no distinct image of its own.
  function resolveAltProduct(entry, targetViscosity){
    if (!entry.variants) return entry;
    var chosen = pickClosestViscosityVariant(entry.variants, targetViscosity);
    return {
      title: entry.title,
      handle: entry.handle,
      image: (chosen && chosen.image) || entry.image,
      bottleSizeL: entry.bottleSizeL,
      variantId: chosen ? chosen.variantId : null,
      variantTitle: chosen ? formatViscosityVariantTitle(chosen.viscosity, entry.bottleSizeL) : '',
      price: chosen ? chosen.price : null
    };
  }

  function getAltProductForBrand(brandSlug, grade, catalog, targetViscosity){
    var brandTable = (catalog || ALT_PRODUCTS)[brandSlug];
    if (!brandTable) return null;
    if (brandTable[grade]) return { product: resolveAltProduct(brandTable[grade], targetViscosity), actualGrade: grade };
    for (var i = 0; i < GRADE_FALLBACK_ORDER.length; i++){
      var g = GRADE_FALLBACK_ORDER[i];
      if (brandTable[g]) return { product: resolveAltProduct(brandTable[g], targetViscosity), actualGrade: g };
    }
    return null;
  }

  // Which oil-type pills to offer for a given brand (2026-09-16, oil-grade
  // toggle) — whichever grades that brand's real per-grade collection
  // actually carries (see ALT_PRODUCTS / ALT_PRODUCTS_2STROKE above), in a
  // fixed best-to-basic display order. A brand with only one grade (Klotz)
  // returns a single-item list, which the UI reads as "no real choice here"
  // and hides the toggle entirely, per Derek's "don't offer a choice that
  // isn't one" — same instinct as the 5-brand OEM primary-brand logic.
  function getAvailableGrades(bike, brandSlug){
    // Deliberately 4-stroke only for now, per Derek (2026-09-16): "let's
    // start with four-stroke and see how it looks, then figure out a plan
    // for two-stroke." The 2-stroke catalog is structurally ready for the
    // same toggle (ALT_PRODUCTS_2STROKE is keyed the same way), but
    // 2-stroke grade selection interacts with mix-ratio copy in a way that
    // hasn't been designed yet — so a 2-stroke bike gets no toggle at all
    // until that follow-up.
    if (isTwoStrokeBike(bike)) return [];
    var brandTable = ALT_PRODUCTS[brandSlug];
    if (!brandTable) return [];
    var grades = GRADE_FALLBACK_ORDER.filter(function(g){ return !!brandTable[g]; });
    // 2026-09-16 bug fix: a bike's own curated "exact match" grade doesn't
    // have to exist as a real key in that brand's ALT_PRODUCTS table (e.g.
    // Motul only stocks a Full Synthetic and a Mineral tier in this catalog
    // — there's no separate "Motul Semi-Synthetic" SKU — even though plenty
    // of Honda bikes ship recommending Motul Semi-Synthetic from their own
    // exact viscosity match). Without this, a Semi-Synthetic-default Honda
    // showed a toggle with only [Full Synthetic, Mineral] and neither pill
    // marked active, so the pill that actually matched the screen was
    // missing — a customer (or Derek, testing) clicking "Full Synthetic"
    // thinking it looked like the safe/default option would silently swap
    // off the bike's exact-match oil onto a generic same-brand substitute.
    // So: whenever this is the bike's own primary brand and it has a real
    // exact-match product, always include the bike's true default grade as
    // a pill too, even if the brand table itself doesn't carry that grade
    // as a separate SKU — keeping it correctly highlighted as active, and
    // (per buildOilInfo's isDefaultGrade check) restoring the bike's exact
    // match rather than routing through the alt-catalog fallback search.
    if (brandSlug === bike.primaryBrandSlug && bike.oilVariantId){
      var trueDefault = normalizeGrade(bike.recommendedGrade);
      if (trueDefault && grades.indexOf(trueDefault) === -1){
        grades = GRADE_FALLBACK_ORDER.filter(function(g){ return g === trueDefault || !!brandTable[g]; });
      }
    }
    return grades;
  }

  // The grade label actually reflected by a given oilInfo — the bike's own
  // curated grade for an exact match, or whichever grade the alternate
  // catalog actually matched (which can differ from what was asked for,
  // via GRADE_FALLBACK_ORDER) otherwise. Used anywhere the UI shows the
  // oil's grade, so it never shows a grade different from the product
  // actually on screen.
  function displayGradeFor(bike, oilInfo){
    return oilInfo.exactMatch ? (bike.recommendedGrade || '') : (oilInfo.matchedGrade || bike.recommendedGrade || '');
  }

  // Builds the "current oil selection" object the whole UI renders from.
  // For the bike's own primary brand AT the bike's own recommended grade,
  // use the bike's precomputed exact-viscosity match (best quality). Any
  // other brand, or a customer-chosen grade other than the bike's default
  // (2026-09-16 oil-grade toggle — mineral/semi-synthetic/full-synthetic),
  // falls back to the curated "same grade tier" alternate catalog above.
  function buildOilInfo(bike, brandSlug, grade){
    var isDefaultGrade = grade === normalizeGrade(bike.recommendedGrade);
    if (isDefaultGrade && brandSlug === bike.primaryBrandSlug && bike.oilVariantId){
      return {
        brandSlug: brandSlug,
        variantId: bike.oilVariantId,
        handle: bike.oilProductHandle,
        image: bike.oilProductImage,
        title: bike.oilProductTitle,
        variantTitle: bike.oilVariantTitle,
        price: bike.oilVariantPrice,
        bottleSizeL: bike.oilBottleSizeL || 1,
        suggestedQty: Math.max(1, bike.oilSuggestedQty || 1),
        exactMatch: true
      };
    }
    // Two-stroke bikes need a two-stroke oil when swapping brands/grades —
    // the 4-stroke ALT_PRODUCTS table above is the wrong catalog for them
    // (see ALT_PRODUCTS_2STROKE's comment for the bug this fixes).
    var altCatalog = isTwoStrokeBike(bike) ? ALT_PRODUCTS_2STROKE : ALT_PRODUCTS;
    var found = getAltProductForBrand(brandSlug, grade, altCatalog, bike.viscosity);
    if (!found) return null;
    var p = found.product;
    var suggestedQty = bike.oilCapacityLNum
      ? Math.max(1, Math.ceil(bike.oilCapacityLNum / (p.bottleSizeL || 1)))
      : (bike.oilSuggestedQty || 1);
    return {
      brandSlug: brandSlug,
      variantId: p.variantId,
      handle: p.handle,
      image: p.image,
      title: p.title,
      variantTitle: p.variantTitle,
      price: p.price,
      bottleSizeL: p.bottleSizeL || 1,
      suggestedQty: suggestedQty,
      exactMatch: false,
      matchedGrade: found.actualGrade
    };
  }

  var MAX_KIT_MULTIPLIER = 4;

  // ---- "Does THIS product fit your bike?" per-product fit-checker ----
  // (2026-10-28, per Derek: a shopper who lands on one specific product
  // page — from Google or an AI answer — wants to know whether THIS item
  // fits THEIR bike, not just see a list of things that do. Scope is all
  // job categories from day one, per Derek's own call.)
  //
  // Brand comes from the product's own Shopify vendor field. Category
  // comes from the product's own job-code tag — the same MCS/MCD/MCV ×
  // EO/2SEO/TG/SF/BC/PT/CHMAIN/COOL taxonomy that already drives smart
  // collections and this file's own cross-sell grid — rather than a new,
  // separate reverse lookup against the per-brand product tables above.
  // That matters: those tables only hold ONE curated SKU per brand per
  // category (e.g. CROSS_SELL_PRODUCTS.trans.motorex is the 10W30 "Moto
  // Gear Oil"), but the catalog genuinely carries several real gear-oil
  // products per brand at different weights (10W30, 10W40, 75W90, 80W90…
  // confirmed live against the Shopify catalog while designing this). A
  // handle-equality check against the curated table would wrongly call
  // every one of those other real products "not a match" for any bike.
  // Reading the category straight off the product's own tag sidesteps
  // that gap entirely, and is also exactly how this shop already decides
  // what a product is for everywhere else (collections, this cross-sell
  // grid), so the new verdict can never disagree with them.
  var VENDOR_TO_FIT_CHECK_BRAND_SLUG = {
    'MOTOREX': 'motorex',
    'MOTUL': 'motul',
    'LIQUI MOLY': 'liqui-moly',
    'MAXIMA RACING OIL': 'maxima',
    'KLOTZ': 'klotz'
  };

  var FIT_CHECK_JOB_CODES = [
    { code: '2SEO', category: 'twostroke' },
    { code: 'EO', category: 'engine' },
    { code: 'TG', category: 'trans' },
    { code: 'SF', category: 'fork' },
    { code: 'BC', category: 'brake' },
    { code: 'PT', category: 'primary' },
    { code: 'CHMAIN', category: 'chain' },
    { code: 'COOL', category: 'coolant' }
  ];

  var FIT_CHECK_CATEGORY_LABELS = {
    engine: 'engine oil',
    twostroke: '2-stroke oil',
    trans: 'transmission/gear oil',
    fork: 'fork oil',
    brake: 'brake fluid',
    primary: 'primary oil',
    chain: 'chain lube/cleaner',
    coolant: 'coolant'
  };

  // tags: array of raw Shopify tag strings (e.g. "MCD TG", "mcd sf",
  // "SXS/ATV BC", "CHMAIN"). Checked as whole, case-insensitive tokens
  // split on whitespace so "TG"/"EO" never accidentally match inside a
  // longer tag like "2SEO" or a brand/chemistry tag.
  function resolveFitCheckCategory(tags){
    if (!Array.isArray(tags)) return null;
    for (var i = 0; i < tags.length; i++){
      var tokens = String(tags[i] || '').toUpperCase().split(/\s+/);
      for (var j = 0; j < tokens.length; j++){
        for (var k = 0; k < FIT_CHECK_JOB_CODES.length; k++){
          if (tokens[j] === FIT_CHECK_JOB_CODES[k].code) return FIT_CHECK_JOB_CODES[k].category;
        }
      }
    }
    return null;
  }

  // Whether/why this job category applies to the selected bike at all —
  // reuses the exact same gates the "Complete the job" cross-sell grid
  // already uses for each category (isNA on the relevant sheet column,
  // isTwoStrokeBike, isLiquidCooledBike, drive system) so this can never
  // tell a shopper "fits"/"doesn't fit" in a way that disagrees with what
  // that grid shows for the same bike.
  function fitCheckApplicability(category, bike){
    switch (category){
      case 'engine':
        if (bike.oilNotApplicable) return { applicable: false, reason: bike.oilNotApplicableReason || "This bike doesn't use engine oil." };
        if (isTwoStrokeBike(bike)) return { applicable: false, reason: 'Your bike is two-stroke and runs on 2-stroke pre-mix oil, not standard 4-stroke engine oil.' };
        return { applicable: true };
      case 'twostroke':
        if (bike.oilNotApplicable) return { applicable: false, reason: bike.oilNotApplicableReason || "This bike doesn't use engine oil." };
        if (!isTwoStrokeBike(bike)) return { applicable: false, reason: "Your bike is a 4-stroke and doesn't run on 2-stroke pre-mix oil." };
        return { applicable: true };
      case 'trans':
        if (isNA(bike.transmissionOil)) return { applicable: false, reason: "Your bike's transmission shares oil with the engine, so it doesn't use a separate gear oil like this." };
        return { applicable: true };
      case 'fork':
        var forkWeight = (bike.forkOil || '').trim();
        if (!forkWeight || isNA(forkWeight)) return { applicable: false, reason: "We don't have a conventional fork-oil fill spec on file for this bike." };
        return { applicable: true };
      case 'brake':
        // Every bike — even an electric one — still has hydraulic brakes.
        return { applicable: true };
      case 'primary':
        if (isNA(bike.chaindriveOil)) return { applicable: false, reason: "Your bike doesn't have a separate wet primary case, so this product isn't used on it." };
        return { applicable: true };
      case 'chain':
        var drive = (bike.driveSystem || '').trim();
        if (/^shaft/i.test(drive)) return { applicable: false, reason: 'Your bike uses a shaft final drive, not a chain — it needs shaft-drive gear oil instead of chain lube.' };
        if (!drive || /^belt/i.test(drive)) return { applicable: false, reason: "Your bike uses a belt final drive, which doesn't use chain lube or cleaner." };
        return { applicable: true };
      case 'coolant':
        if (!isLiquidCooledBike(bike)) return { applicable: false, reason: "Your bike is air-cooled and doesn't use coolant." };
        return { applicable: true };
      default:
        return { applicable: false, reason: '' };
    }
  }

  // Renders the verdict card. brandSlug/category are resolved once at
  // init time from the product page's own vendor/tags (see initSection) —
  // null for any product outside the 5 oil brands or with no job-code tag
  // (accessories, filters, cleaning kits, the homepage), in which case the
  // card stays hidden rather than guessing.
  function renderFitCheck(root, state, bike){
    var cardEl = root.querySelector('[data-fby-fit-check]');
    if (!cardEl) return;
    var brandSlug = state.fitCheckBrandSlug;
    var category = state.fitCheckCategory;
    if (!bike || !brandSlug || !category){
      cardEl.hidden = true;
      return;
    }

    var titleEl = cardEl.querySelector('[data-fby-fit-check-title]');
    var bodyEl = cardEl.querySelector('[data-fby-fit-check-body]');
    var bikeLabel = bike.yearLabel + ' ' + bike.make + ' ' + bike.model;
    var check = fitCheckApplicability(category, bike);

    cardEl.hidden = false;
    cardEl.classList.remove('fby-fit-check-yes', 'fby-fit-check-alt', 'fby-fit-check-no');

    if (!check.applicable){
      cardEl.classList.add('fby-fit-check-no');
      titleEl.textContent = 'Not for your ' + bikeLabel;
      bodyEl.textContent = check.reason;
      return;
    }

    var brandName = crossSellBrandName(brandSlug);
    var categoryLabel = FIT_CHECK_CATEGORY_LABELS[category] || 'product';

    if (brandSlug === bike.primaryBrandSlug){
      cardEl.classList.add('fby-fit-check-yes');
      titleEl.textContent = '✓ Fits your ' + bikeLabel;
      bodyEl.textContent = isOemMatch(brandSlug, bike.make)
        ? (brandName + ' is ' + bike.make + '’s factory-recommended oil brand, and this is their ' + categoryLabel + ' for your bike.')
        : (brandName + ' is the brand we recommend for your bike, and this is their ' + categoryLabel + '.');
    } else {
      cardEl.classList.add('fby-fit-check-alt');
      titleEl.textContent = 'Works for your ' + bikeLabel;
      bodyEl.textContent = 'This is a compatible ' + categoryLabel + ' for your bike. ' + crossSellBrandName(bike.primaryBrandSlug) + ' is the brand we’d recommend first for it, if you’d like everything to match.';
    }
  }

  function initSection(root){
    var dataUrls = [];
    try { dataUrls = JSON.parse(root.getAttribute('data-bikes-urls') || '[]'); } catch(e){ dataUrls = []; }
    var state = { bikes: [], selected: null, oil: null, filterQty: 1, kitMultiplier: 1, filterAvailable: false, selectedGrade: null };

    // Resolved once from this page's own product context (blank/absent on
    // the homepage and on any non-product-page use of this section, and
    // left null — fit-check card simply never shows — for any vendor or
    // job category outside the 5 oil brands' lubricant/fluid tagging).
    var fitCheckVendor = (root.getAttribute('data-fby-current-vendor') || '').toUpperCase().trim();
    var fitCheckTags = (root.getAttribute('data-fby-current-tags') || '').split('|');
    state.fitCheckBrandSlug = VENDOR_TO_FIT_CHECK_BRAND_SLUG[fitCheckVendor] || null;
    state.fitCheckCategory = state.fitCheckBrandSlug ? resolveFitCheckCategory(fitCheckTags) : null;

    var makeSel = root.querySelector('[data-fby-make]');
    var modelSel = root.querySelector('[data-fby-model]');
    var yearSel = root.querySelector('[data-fby-year]');
    var findBtn = root.querySelector('[data-fby-find]');
    var results = root.querySelector('[data-fby-results]');
    var stepCard = root.querySelector('[data-fby-step]');
    var ctxBike = root.querySelector('[data-fby-ctx-bike]');
    var changeBtn = root.querySelector('[data-fby-change]');

    Promise.all(dataUrls.map(function(u){ return fetch(u).then(function(r){ return r.json(); }); }))
      .then(function(parts){
        state.bikes = parts.reduce(function(acc, part){ return acc.concat(part); }, []);
        populateMakes();
        // Pre-fill from a bike already remembered elsewhere on the site
        // (e.g. the "Does This Product Fit Your Bike?" widget above), so
        // the customer isn't asked to re-enter a bike they already gave us
        // (2026-10-29, Derek). See applySharedBike() below for the
        // flybyu_selected_bike / flybyu:bike-selected contract.
        try {
          var storedRaw = localStorage.getItem('flybyu_selected_bike');
          if (storedRaw){ applySharedBike(JSON.parse(storedRaw)); }
        } catch (e) {}
      }).catch(function(){
        stepCard.innerHTML = '<p style="color:#8c857a;font-size:13px;">We couldn\'t load the bike lookup right now. Please refresh the page.</p>';
      });

    function uniqueSorted(arr){
      return Array.from(new Set(arr)).sort(function(a,b){ return a.localeCompare(b); });
    }

    function populateSelect(sel, values, placeholder){
      sel.innerHTML = '';
      var ph = document.createElement('option');
      ph.value = ''; ph.textContent = placeholder; ph.disabled = true; ph.selected = true;
      sel.appendChild(ph);
      values.forEach(function(v){
        var o = document.createElement('option');
        o.value = v; o.textContent = v;
        sel.appendChild(o);
      });
      sel.disabled = false;
    }

    function populateMakes(){
      populateSelect(makeSel, uniqueSorted(state.bikes.map(function(b){ return b.make; })), 'Select make');
      modelSel.disabled = true; yearSel.disabled = true;
      populateSelect(modelSel, [], 'Select make first');
      populateSelect(yearSel, [], 'Select model first');
      updateFindState();
    }

    makeSel.addEventListener('change', function(){
      var make = makeSel.value;
      var models = uniqueSorted(state.bikes.filter(function(b){ return b.make === make; }).map(function(b){ return b.model; }));
      populateSelect(modelSel, models, 'Select model');
      populateSelect(yearSel, [], 'Select model first');
      yearSel.disabled = true;
      updateFindState();
    });

    modelSel.addEventListener('change', function(){
      var make = makeSel.value, model = modelSel.value;
      var rows = state.bikes.filter(function(b){ return b.make === make && b.model === model; });
      // Expand each row's year range into individual selectable years, so a
      // customer can pick their bike's exact model year (e.g. 2022) even
      // though several years share the same underlying spec row. Newest
      // year first.
      var yearMap = {};
      rows.forEach(function(row){
        var startY = parseInt(row.yearStart, 10);
        var endY = parseInt(row.yearEnd, 10);
        if (!isNaN(startY) && !isNaN(endY) && endY >= startY){
          for (var y = startY; y <= endY; y++){ yearMap[String(y)] = row; }
        } else if (row.yearLabel) {
          yearMap[row.yearLabel] = row;
        }
      });
      state.yearMap = yearMap;
      var years = Object.keys(yearMap).sort(function(a,b){ return parseInt(b,10) - parseInt(a,10); });
      populateSelect(yearSel, years, 'Select year');
      if (years.length === 1){ yearSel.value = years[0]; }
      updateFindState();
    });

    yearSel.addEventListener('change', updateFindState);

    function updateFindState(){
      findBtn.disabled = !(makeSel.value && modelSel.value && yearSel.value);
    }

    findBtn.addEventListener('click', function(){
      var pickedYear = yearSel.value;
      var match = state.yearMap && state.yearMap[pickedYear];
      if (!match) return;
      // Work on a private copy so brand-swap never mutates the shared dataset.
      state.selected = Object.assign({}, match);
      // Show the customer's exact picked year everywhere (results, the
      // sticky bike bar), even though the underlying spec row is shared
      // across a range of years.
      state.selected.yearLabel = pickedYear;
      state.selected.selectedYear = pickedYear;
      state.filterQty = 1;
      state.kitMultiplier = 1;
      renderResults(state.selected);
      results.classList.add('fby-show');
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      try {
        localStorage.setItem('flybyu_selected_bike', JSON.stringify(state.selected));
        window.dispatchEvent(new CustomEvent('flybyu:bike-selected', { detail: state.selected }));
      } catch (e) {}
    });

    changeBtn.addEventListener('click', function(){
      results.classList.remove('fby-show');
      root.querySelector('[data-fby-picker]').scrollIntoView({ behavior: 'smooth', block: 'start' });
      try {
        localStorage.removeItem('flybyu_selected_bike');
        window.dispatchEvent(new CustomEvent('flybyu:bike-cleared'));
      } catch (e) {}
    });

    // Keep this picker's SELECTION in sync with the shared "remembered
    // bike" that the top "Does This Product Fit Your Bike?" widget (and
    // this picker's own "Find My Products" button) write to
    // flybyu_selected_bike / flybyu:bike-selected — see the contract
    // comment in snippets/flybyu-fit-check-widget.liquid. Before this, a
    // bike already known elsewhere on the page still had to be re-entered
    // here, and a bike changed in one spot didn't update the other while
    // the page stayed open, so two different bikes could be showing on the
    // same page at once (2026-10-29, Derek).
    //
    // Deliberately pre-fills the Make/Model/Year selects ONLY — it does
    // NOT reveal the results. Per Derek (2026-10-29): autofilling the
    // picker is convenient, but clicking "Find My Products" is the
    // customer's own deliberate action that says "yes, show me everything
    // for THIS bike" — so seeing the full product list always follows an
    // explicit click, never an automatic sync, even when the bike itself
    // came from elsewhere on the page. If a different bike's results were
    // already showing, they're collapsed here so they can't be mistaken
    // for a match to the newly-filled-in selection.
    function applySharedBike(bike){
      if (!bike || !bike.make || !bike.model || !state.bikes.length) return;
      var yearLabel = bike.yearLabel || bike.selectedYear;
      if (!yearLabel) return;

      var rows = state.bikes.filter(function(b){ return b.make === bike.make && b.model === bike.model; });
      if (!rows.length) return; // not in this page's dataset shard — leave the picker as-is

      var yearMap = {};
      rows.forEach(function(row){
        var startY = parseInt(row.yearStart, 10);
        var endY = parseInt(row.yearEnd, 10);
        if (!isNaN(startY) && !isNaN(endY) && endY >= startY){
          for (var y = startY; y <= endY; y++){ yearMap[String(y)] = row; }
        } else if (row.yearLabel) {
          yearMap[row.yearLabel] = row;
        }
      });
      if (!yearMap[yearLabel]) return;

      var models = uniqueSorted(state.bikes.filter(function(b){ return b.make === bike.make; }).map(function(b){ return b.model; }));
      var years = Object.keys(yearMap).sort(function(a,b){ return parseInt(b,10) - parseInt(a,10); });
      populateSelect(makeSel, uniqueSorted(state.bikes.map(function(b){ return b.make; })), 'Select make');
      makeSel.value = bike.make;
      populateSelect(modelSel, models, 'Select model');
      modelSel.value = bike.model;
      populateSelect(yearSel, years, 'Select year');
      yearSel.value = yearLabel;
      // So a straight-off click of "Find My Products" works immediately —
      // that handler reads state.yearMap, normally only built by the
      // Model select's own 'change' handler further up.
      state.yearMap = yearMap;
      updateFindState();

      // Collapse any results already showing for a now-stale selection,
      // and clear the old pick — the customer hasn't asked for THIS bike's
      // results yet, only had it filled in for them.
      state.selected = null;
      results.classList.remove('fby-show');
    }

    function resetPicker(){
      state.selected = null;
      results.classList.remove('fby-show');
      populateMakes();
    }

    // Skip the echo of this picker's OWN just-dispatched bike (reference
    // equality against state.selected, which the click handler above sets
    // to the exact object it then dispatches) — otherwise this picker's
    // own "Find My Products" click would immediately collapse the results
    // it just revealed, via its own event bouncing back to it (bug caught
    // in live testing, 2026-10-29). A bike that genuinely came from
    // elsewhere (the top widget) is never reference-equal to
    // state.selected, so it still pre-fills normally.
    window.addEventListener('flybyu:bike-selected', function(e){
      if (e && e.detail === state.selected) return;
      applySharedBike(e && e.detail);
    });
    window.addEventListener('flybyu:bike-cleared', resetPicker);

    // Product detail modal (2026-09-13): clicking a product photo or a
    // "View details" link shows a bigger picture plus the real Shopify
    // product description, fetched live from that product's own page —
    // never invented copy. Price/title/image shown immediately come from
    // the same trusted data already on the card; only the longer
    // description (and any extra photos) are fetched, and only for
    // products that have a real handle on this bike.
    var productInfoCache = {};

    function closeProductModal(){
      var overlay = root.querySelector('[data-fby-modal-overlay]');
      if (overlay) overlay.style.display = 'none';
      document.body.style.overflow = '';
    }

    function applyProductDescription(data, bodyEl){
      var descEl = bodyEl.querySelector('[data-fby-modal-desc]');
      if (!descEl) return;
      descEl.innerHTML = (data && data.description)
        ? data.description
        : '<span class="fby-modal-desc-loading">See the full product page for more details.</span>';
      if (data && data.images && data.images.length > 1){
        var extra = document.createElement('div');
        extra.className = 'fby-modal-extra-images';
        data.images.slice(1, 4).forEach(function(src){
          var img = document.createElement('img');
          img.src = src;
          img.alt = '';
          extra.appendChild(img);
        });
        descEl.parentNode.insertBefore(extra, descEl.nextSibling);
      }
    }

    function loadProductDescription(handle, bodyEl){
      if (productInfoCache[handle]){
        applyProductDescription(productInfoCache[handle], bodyEl);
        return;
      }
      fetch('/products/' + handle + '.js')
        .then(function(r){ if (!r.ok) throw new Error('not ok'); return r.json(); })
        .then(function(data){
          productInfoCache[handle] = data;
          applyProductDescription(data, bodyEl);
        })
        .catch(function(){
          var descEl = bodyEl.querySelector('[data-fby-modal-desc]');
          if (descEl) descEl.innerHTML = '';
        });
    }

    function showProductModal(data){
      var overlay = root.querySelector('[data-fby-modal-overlay]');
      var body = root.querySelector('[data-fby-modal-body]');
      if (!overlay || !body) return;
      var hasVariants = !!(data.variants && data.variants.length > 1);
      var html = '';
      html += '<img class="fby-modal-img" src="' + (data.image || '') + '" alt="">';
      html += '<div class="fby-modal-title">' + escHtml(data.title || '') + '</div>';
      if (data.variantMeta) html += '<div class="fby-modal-variant">' + escHtml(data.variantMeta) + '</div>';
      if (hasVariants){
        // Multi-variant products (e.g. a cleaner sold in more than one
        // size) get a size picker + their own Add to Cart here instead of
        // a plain price, so a customer can't accidentally buy the wrong
        // size from a single quick-add click.
        html += '<div class="fby-modal-variant-picker" data-fby-modal-variant-picker></div>';
        html += '<button type="button" class="fby-add-btn-sm fby-modal-add-btn" data-fby-modal-add-btn disabled>Select a size</button>';
        html += '<div class="fby-add-msg" data-fby-modal-add-msg></div>';
      } else {
        html += '<div class="fby-modal-price">' + data.price + '</div>';
        // Derek's request (2026-09-18): let a shopper add straight from
        // the modal after reading the description, instead of having to
        // close it and hunt down the row's own button — covers the oil
        // card, the filter, "Complete the job" rows, and single-size
        // Cleaning & Detailing / Maintenance Products / Fuel Stabilizers &
        // Additives rows (the only single-variant callers of this modal).
        // Multi-variant products keep the size-picker flow above instead.
        if (data.variantId){
          html += '<button type="button" class="fby-add-btn-sm fby-modal-add-btn" data-fby-modal-simple-add data-variant-id="' + escAttr(data.variantId) + '">Add to Cart</button>';
          html += '<div class="fby-add-msg" data-fby-modal-add-msg></div>';
        }
      }
      html += '<div class="fby-modal-desc" data-fby-modal-desc><span class="fby-modal-desc-loading">Loading description…</span></div>';
      if (data.handle) html += '<a class="fby-modal-link" href="/products/' + data.handle + '" target="_blank" rel="noopener">View full product page →</a>';
      body.innerHTML = html;
      overlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      if (hasVariants){
        renderModalVariantPicker(data.variants, body);
      } else if (data.variantId){
        wireModalSimpleAddButton(body);
      }
      if (data.handle){
        loadProductDescription(data.handle, body);
      } else {
        var descElNoHandle = body.querySelector('[data-fby-modal-desc]');
        if (descElNoHandle) descElNoHandle.innerHTML = '';
      }
    }

    // Renders the size-choice buttons + wires the modal's own Add to Cart
    // for a multi-variant product. Built from the variant data the row
    // already fetched (see cleanProductRow) — no extra network call needed
    // just to show the picker.
    function renderModalVariantPicker(variants, body){
      var host = body.querySelector('[data-fby-modal-variant-picker]');
      var addBtn = body.querySelector('[data-fby-modal-add-btn]');
      var msgEl = body.querySelector('[data-fby-modal-add-msg]');
      if (!host || !addBtn) return;
      var selectedId = null;
      host.innerHTML = variants.map(function(v){
        return '<button type="button" class="fby-modal-variant-choice' + (v.available === false ? ' fby-modal-variant-choice-oos' : '') + '"' +
          ' data-variant-id="' + escAttr(v.id) + '"' + (v.available === false ? ' disabled' : '') + '>' +
          '<span class="fby-modal-variant-choice-title">' + escHtml(v.title) + '</span>' +
          '<span class="fby-modal-variant-choice-price">' + (v.available === false ? 'Out of stock' : (CURRENCY_PREFIX + parseFloat(v.price).toFixed(2))) + '</span>' +
        '</button>';
      }).join('');
      host.querySelectorAll('[data-variant-id]:not([disabled])').forEach(function(btn){
        btn.addEventListener('click', function(){
          host.querySelectorAll('.fby-modal-variant-choice').forEach(function(b){ b.classList.remove('fby-modal-variant-choice-active'); });
          btn.classList.add('fby-modal-variant-choice-active');
          selectedId = btn.getAttribute('data-variant-id');
          addBtn.disabled = false;
          addBtn.textContent = 'Add to Cart';
          addBtn.classList.remove('fby-added');
        });
      });
      addBtn.addEventListener('click', function(){
        if (!selectedId) return;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(selectedId, 10), quantity: 1 }] })
        }).then(function(r){ if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function(){
            addBtn.disabled = false;
            addBtn.textContent = 'Added ✓';
            addBtn.classList.add('fby-added');
            if (msgEl) msgEl.innerHTML = '<a href="/cart">View cart</a>';
            notifyCartUpdated();
          }).catch(function(){
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
            if (msgEl) msgEl.textContent = 'Something went wrong — please try again.';
          });
      });
    }

    // Single-item Add to Cart for the modal's non-variant-picker case
    // (see the comment above where data.variantId is checked) — same
    // /cart/add.js call and sold-out handling as the other quick-add
    // buttons on this page (addCrossSellToCart, addCleanToCart), just
    // wired to the modal's own button.
    function wireModalSimpleAddButton(body){
      var btn = body.querySelector('[data-fby-modal-simple-add]');
      var msgEl = body.querySelector('[data-fby-modal-add-msg]');
      if (!btn) return;
      btn.addEventListener('click', function(){
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        }).then(function(r){
          if (!r.ok) return r.json().then(function(err){ throw err; });
          return r.json();
        }).then(function(){
          btn.disabled = false;
          btn.textContent = 'Added ✓';
          btn.classList.add('fby-added');
          if (msgEl) msgEl.innerHTML = '<a href="/cart">View cart</a>';
          notifyCartUpdated();
        }).catch(function(err){
          var isSoldOut = err && (err.status === 422 || /sold out|not enough|only \d+ available/i.test(err.message || err.description || ''));
          if (isSoldOut){
            btn.disabled = true;
            btn.textContent = 'Out of Stock';
            btn.classList.add('fby-add-btn-oos');
            if (msgEl) msgEl.textContent = 'Currently out of stock.';
          } else {
            btn.disabled = false;
            btn.textContent = 'Add to Cart';
            if (msgEl) msgEl.textContent = 'Something went wrong — please try again.';
          }
        });
      });
    }

    function openProductModal(kind, triggerEl){
      if (kind === 'oil'){
        if (!state.oil) return;
        showProductModal({
          handle: state.oil.handle,
          title: state.oil.title,
          variantMeta: (state.oil.variantTitle && state.oil.variantTitle !== 'Default Title') ? state.oil.variantTitle : '',
          price: CURRENCY_PREFIX + parseFloat(state.oil.price || '0').toFixed(2),
          image: state.oil.image,
          variantId: state.oil.variantId
        });
      } else if (kind === 'filter'){
        if (!state.selected || !state.selected.oilFilterVariantId) return;
        var filterCode = (state.selected.oilFilterCode && state.selected.oilFilterCode !== 'N/A') ? state.selected.oilFilterCode : '';
        showProductModal({
          handle: state.selected.oilFilterHandle,
          title: filterCode ? ('HIFLO Oil Filter ' + filterCode) : 'Oil Filter',
          variantMeta: '',
          price: CURRENCY_PREFIX + parseFloat(state.selected.oilFilterPrice || '0').toFixed(2),
          image: state.selected.oilFilterImage,
          variantId: state.selected.oilFilterVariantId
        });
      } else if (kind === 'crosssell' || kind === 'clean'){
        // "Complete the job" product photos (brake fluid, transmission oil,
        // coolant, primary oil, fork oil, chain care/cleaner) and Cleaning
        // & Detailing rows both use this same modal, with the product data
        // stashed on the trigger element itself (by crossSellProductRow or
        // cleanProductRow) rather than read from `state` — a category can
        // show any brand's/any collection's product depending on context.
        // Cleaning rows additionally may carry a variants list (multi-size
        // products); "Complete the job" rows never do, so this stays a
        // no-op there, unchanged from before.
        if (!triggerEl) return;
        var variantMeta = triggerEl.getAttribute('data-fby-modal-variant') || '';
        var variantsRaw = triggerEl.getAttribute('data-fby-modal-variants');
        var variants = null;
        if (variantsRaw){
          try { variants = JSON.parse(variantsRaw); } catch (err) { variants = null; }
        }
        var singleVariantId = triggerEl.getAttribute('data-fby-modal-variant-id') || '';
        showProductModal({
          handle: triggerEl.getAttribute('data-fby-modal-handle') || '',
          title: triggerEl.getAttribute('data-fby-modal-title') || '',
          variantMeta: (variantMeta && variantMeta !== 'Default Title') ? variantMeta : '',
          price: CURRENCY_PREFIX + parseFloat(triggerEl.getAttribute('data-fby-modal-price') || '0').toFixed(2),
          image: triggerEl.getAttribute('data-fby-modal-image') || '',
          variantId: (variants && variants.length > 1) ? null : (singleVariantId || null),
          variants: (variants && variants.length > 1) ? variants : null
        });
      }
    }

    root.addEventListener('click', function(e){
      var trigger = e.target.closest && e.target.closest('[data-fby-modal-open]');
      if (trigger){
        e.preventDefault();
        openProductModal(trigger.getAttribute('data-fby-modal-open'), trigger);
      }
    });
    var modalCloseBtn = root.querySelector('[data-fby-modal-close]');
    var modalOverlayEl = root.querySelector('[data-fby-modal-overlay]');
    if (modalCloseBtn) modalCloseBtn.addEventListener('click', closeProductModal);
    if (modalOverlayEl) modalOverlayEl.addEventListener('click', function(e){ if (e.target === modalOverlayEl) closeProductModal(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeProductModal(); });

    function renderResults(bike){
      // A new bike gets its own default oil-grade selection — a grade a
      // shopper picked for their last bike shouldn't silently carry over.
      state.selectedGrade = null;
      ctxBike.textContent = bike.yearLabel + ' ' + bike.make + ' ' + bike.model;
      var ctxOil = root.querySelector('[data-fby-ctx-oil]');
      renderFitCheck(root, state, bike);

      var primaryHead = root.querySelector('[data-fby-primary-head]');
      var oilSection = root.querySelector('[data-fby-oil-section]');
      var electricNote = root.querySelector('[data-fby-electric-note]');
      var alsoLabel = root.querySelector('.fby-also-label');
      var alsoStrip = root.querySelector('[data-fby-also-strip]');

      if (bike.oilNotApplicable){
        state.oil = null;
        primaryHead.style.display = 'none';
        oilSection.style.display = 'none';
        var gradeToggleEl = root.querySelector('[data-fby-grade-toggle]');
        if (gradeToggleEl) gradeToggleEl.style.display = 'none';
        electricNote.style.display = '';
        root.querySelector('[data-fby-electric-title]').textContent = 'Electric Motorcycle';
        root.querySelector('[data-fby-electric-body]').textContent = (bike.oilNotApplicableReason || 'This bike doesn\'t use engine oil.') + ' Check out the filter and other maintenance options below.';
        if (alsoLabel) alsoLabel.style.display = 'none';
        if (alsoStrip) alsoStrip.style.display = 'none';
        if (ctxOil) ctxOil.textContent = 'Electric motorcycle — no engine oil needed';
        // The capacity note now sits above the oil-section (it's shared
        // context for the combo card), so it needs to be cleared here too
        // — otherwise a stale "your bike takes about X L" note from a
        // previously-viewed petrol bike would keep showing.
        var capacityNoteEl = root.querySelector('[data-fby-capacity-note]');
        if (capacityNoteEl) capacityNoteEl.textContent = '';
      } else {
        primaryHead.style.display = '';
        oilSection.style.display = '';
        electricNote.style.display = 'none';
        if (alsoLabel) alsoLabel.style.display = '';
        if (alsoStrip) alsoStrip.style.display = '';
        if (ctxOil) ctxOil.textContent = '';
        selectBrand(bike.primaryBrandSlug);
      }

      // Filter card
      var filterTitle = root.querySelector('[data-fby-filter-title]');
      var filterFit = root.querySelector('[data-fby-filter-fit]');
      var filterAvailable = !!bike.oilFilterVariantId;
      state.filterAvailable = filterAvailable;
      root.querySelector('[data-fby-filter-available]').style.display = filterAvailable ? '' : 'none';
      root.querySelector('[data-fby-filter-unavailable]').style.display = filterAvailable ? 'none' : '';
      if (bike.oilFilterCode && bike.oilFilterCode !== 'N/A'){
        filterTitle.innerHTML = 'HIFLO Oil Filter <span class="fby-filter-code">' + bike.oilFilterCode + '</span>';
        filterFit.textContent = 'Exact fit for your ' + bike.model;
      } else {
        filterTitle.textContent = 'Oil Filter';
        filterFit.textContent = 'Ask us to confirm the right filter for this bike';
      }
      if (filterAvailable){
        state.filterQty = 1;
        root.querySelector('[data-fby-qty-num]').textContent = '1';
        updateFilterPrice();
        var addBtn = root.querySelector('[data-fby-add-btn]');
        addBtn.textContent = 'Add to Cart';
        addBtn.classList.remove('fby-added');
        root.querySelector('[data-fby-add-msg]').textContent = '';
        addBtn.onclick = function(){ addFilterToCart(addBtn); };
        root.querySelector('[data-fby-qty-minus]').onclick = function(){ changeQty(-1); };
        root.querySelector('[data-fby-qty-plus]').onclick = function(){ changeQty(1); };
      } else {
        var unavailEl = root.querySelector('[data-fby-filter-unavailable]');
        unavailEl.innerHTML = bike.oilFilterCode && bike.oilFilterCode !== 'N/A'
          ? 'Filter code <strong>' + bike.oilFilterCode + '</strong> — <a href="/collections/hiflo-filtro-oil-filters">browse Hiflo filters</a> or ask us to confirm the exact part.'
          : 'No filter listed for this bike — <a href="/collections/hiflo-filtro-oil-filters">browse all Hiflo filters</a>.';
      }

      // Complete the job
      renderCrossSell(bike);

      // Oil-change kit slider (scales oil + filter quantities together)
      initKitSlider();
    }

    // ---- Brand selection (primary render + "also compatible" swap) ----

    function selectBrand(brandSlug){
      var bike = state.selected;
      if (!bike || bike.oilNotApplicable) return;
      var grade = state.selectedGrade || normalizeGrade(bike.recommendedGrade);
      var oilInfo = buildOilInfo(bike, brandSlug, grade);
      if (!oilInfo){
        // The shopper's sticky grade choice isn't offered at all for this
        // brand (shouldn't normally happen — getAvailableGrades gates what
        // the toggle can even show — but fail safe back to the brand's own
        // default rather than showing nothing).
        state.selectedGrade = null;
        grade = normalizeGrade(bike.recommendedGrade);
        oilInfo = buildOilInfo(bike, brandSlug, grade);
      }
      if (!oilInfo) return;
      state.oil = oilInfo;
      // Keep the sticky grade in sync with what's ACTUALLY on screen, not
      // just what was asked for — a brand that doesn't carry the requested
      // grade falls back (see GRADE_FALLBACK_ORDER), and the grade toggle's
      // active pill needs to reflect that real fallback, not the original
      // ask, on the next render (brand swap, requote, etc.).
      state.selectedGrade = normalizeGrade(displayGradeFor(bike, oilInfo));

      var brand = BRANDS[brandSlug] || { name: bike.primaryBrand, logo: '', handle: brandSlug };

      root.querySelector('[data-fby-primary-logo]').src = brand.logo;
      root.querySelector('[data-fby-primary-name]').textContent = brand.name + ' Engine Oil';
      var viscosity = extractViscosity(oilInfo.variantTitle) || bike.viscosity || '';
      root.querySelector('[data-fby-primary-grade]').textContent =
        (displayGradeFor(bike, oilInfo) || 'Recommended grade') + (viscosity ? ' · ' + viscosity : '');
      renderGradeToggle(brandSlug);

      root.querySelector('[data-fby-oil-title]').textContent = oilInfo.title || (brand.name + ' Engine Oil');
      root.querySelector('[data-fby-oil-meta]').textContent = oilInfo.variantTitle && oilInfo.variantTitle !== 'Default Title'
        ? oilInfo.variantTitle : (bike.viscosity || '');

      var capacityNote = root.querySelector('[data-fby-capacity-note]');
      var mixRatioNum = parseMixRatio(bike.mixRatio);
      if (mixRatioNum){
        // Two-stroke bike: the sheet's "engine oil capacity" field isn't a
        // real sump size for these (premix, no oil reservoir), so show the
        // mix ratio and how much oil that takes to mix a 20L fuel can
        // instead of the 4-stroke "takes about X L, suggest Y bottles" copy.
        var mixMl = mixOilMlFor20L(mixRatioNum);
        var mixQualifier = oilInfo.exactMatch ? '' : ' (closest match — not an exact spec swap)';
        capacityNote.innerHTML = 'Mix ratio <strong>' + escHtml(bike.mixRatio) + '</strong> — you\'ll use about <strong>' + mixMl + 'ml</strong> of oil to mix a 20L can of fuel at ' + escHtml(bike.mixRatio) + '.' + mixQualifier;
      } else if (bike.oilCapacityLNum){
        var bottleText = oilInfo.bottleSizeL ? (oilInfo.bottleSizeL + 'L bottles') : 'bottle';
        var qualifier = oilInfo.exactMatch ? '' : ' (closest match — not an exact spec swap)';
        capacityNote.innerHTML = 'Your bike takes about <strong>' + bike.oilCapacityLNum + 'L</strong> of oil. Based on this product\'s ' + bottleText + ', we suggest <strong>' + oilInfo.suggestedQty + ' bottle' + (oilInfo.suggestedQty === 1 ? '' : 's') + '</strong> per oil change' + qualifier + '.';
      } else {
        capacityNote.textContent = '';
      }

      oilInfo.qty = Math.max(1, Math.min(48, oilInfo.suggestedQty || 1));
      var oilAddBtn = root.querySelector('[data-fby-oil-add-btn]');
      oilAddBtn.style.display = '';
      root.querySelector('[data-fby-oil-qty-num]').textContent = String(oilInfo.qty);
      updateOilPrice();
      oilAddBtn.textContent = 'Add to Cart';
      oilAddBtn.classList.remove('fby-added');
      root.querySelector('[data-fby-oil-add-msg]').textContent = '';
      oilAddBtn.onclick = function(){ addOilToCart(oilAddBtn); };
      root.querySelector('[data-fby-oil-qty-minus]').onclick = function(){ changeOilQty(-1); };
      root.querySelector('[data-fby-oil-qty-plus]').onclick = function(){ changeOilQty(1); };

      root.querySelector('[data-fby-why-brand]').textContent = brand.name + '?';
      root.querySelector('[data-fby-why-body]').textContent = getWhyCopy(bike, brandSlug, brand.name);

      renderAlsoStrip(brandSlug);
      updateKitHeaderPhotos();

      // Re-apply whatever multiplier the shopper had already chosen, so
      // swapping brands mid-way through doesn't reset their quantity choice.
      if (state.kitMultiplier > 1){
        applyKitMultiplier(state.kitMultiplier);
      } else {
        updateKitSummary();
      }

      // "Complete the job" (brake fluid, trans/gear oil, fork oil, chain
      // care) should follow the brand the shopper just switched to, not
      // stay pinned to the bike's static sheet-defined primary brand —
      // this re-render is what makes that happen on every brand swap
      // (renderCrossSell reads primarySlug from state.oil.brandSlug,
      // which we just set above). The one deliberate exception is the
      // TWIN Primary Oil card, which is a single fixed Motul product
      // with no equivalent from other brands and can't follow a swap.
      renderCrossSell(bike);
    }

    // Oil-type toggle (Mineral / Semi-Synthetic / Full Synthetic) — added
    // 2026-09-16 per Derek. Re-rendered on every brand change (grade
    // availability is per-brand) as well as on grade clicks. A brand with
    // only one real grade in the catalog (Klotz) hides the row entirely
    // rather than showing a single, unclickable-feeling pill.
    function renderGradeToggle(brandSlug){
      var wrap = root.querySelector('[data-fby-grade-toggle]');
      var rowEl = root.querySelector('[data-fby-grade-btn-row]');
      if (!wrap || !rowEl) return;
      var bike = state.selected;
      var grades = getAvailableGrades(bike, brandSlug);
      if (grades.length < 2){
        wrap.style.display = 'none';
        rowEl.innerHTML = '';
        return;
      }
      wrap.style.display = '';
      rowEl.innerHTML = '';
      var activeGrade = state.selectedGrade || normalizeGrade(bike.recommendedGrade);
      grades.forEach(function(g){
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fby-grade-choice' + (g === activeGrade ? ' fby-grade-choice-active' : '');
        btn.textContent = g;
        btn.setAttribute('aria-pressed', g === activeGrade ? 'true' : 'false');
        btn.addEventListener('click', function(){
          if (g === state.selectedGrade) return;
          state.selectedGrade = g;
          selectBrand(brandSlug);
        });
        rowEl.appendChild(btn);
      });
    }

    function renderAlsoStrip(currentBrandSlug){
      var alsoStrip = root.querySelector('[data-fby-also-strip]');
      if (!alsoStrip) return;
      alsoStrip.innerHTML = '';
      // Was .slice(0, 2) — hard-capped at 2 chips, which silently dropped
      // Maxima on every bike (it sits last in BRAND_ORDER, so it never made
      // the cut). Maxima already has full, real ALT_PRODUCTS data (4-stroke
      // and 2-stroke, every grade tier) and its own "Why Maxima?" copy, same
      // as every other brand here — it just wasn't being shown. Added
      // 2026-09-16 per Derek: show every brand in BRAND_ORDER other than the
      // one currently selected, so Maxima swaps in and functions exactly
      // like Motorex/Motul/Liqui Moly already do. In practice this is 3
      // chips for a Motorex/Motul/Liqui-Moly-primary bike (was 2), or 4 for
      // a Klotz-primary bike (Klotz itself isn't in BRAND_ORDER — see below).
      var alternates = BRAND_ORDER.filter(function(k){ return k !== currentBrandSlug; });
      alternates.forEach(function(k){
        var b = BRANDS[k];
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fby-also-card';
        btn.innerHTML = '<img src="' + b.logo + '" alt="' + b.name + '"><div class="fby-also-name">Switch to ' + b.name + '</div>';
        btn.addEventListener('click', function(){ selectBrand(k); });
        alsoStrip.appendChild(btn);
      });
    }

    // ---- "Complete the job" brand-based cross-sell ----
    // Renders the brake fluid / transmission oil / chain care cards for
    // the bike's primary brand, each with an expand toggle to see the
    // same category from the other brands we carry. Runs independently of
    // engine-oil applicability (an electric bike still has brakes and a
    // chain), so this always renders once a bike is selected.
    function crossSellProductRow(product, brandSlug, isAlt){
      var brandName = product.brandOverride || crossSellBrandName(brandSlug);
      return '' +
        '<div class="fby-crosssell-row' + (isAlt ? ' fby-crosssell-row-alt' : '') + '">' +
          '<div class="fby-crosssell-photo-col fby-clickable" data-fby-modal-open="crosssell"' +
            ' data-fby-modal-title="' + escAttr(product.title) + '"' +
            ' data-fby-modal-price="' + escAttr(product.price) + '"' +
            ' data-fby-modal-image="' + escAttr(product.image) + '"' +
            ' data-fby-modal-handle="' + escAttr(product.handle || '') + '"' +
            ' data-fby-modal-variant="' + escAttr(product.variantTitle || '') + '"' +
            ' data-fby-modal-variant-id="' + escAttr(product.variantId || '') + '">' +
            '<img class="fby-crosssell-photo" src="' + escHtml(product.image) + '" alt="">' +
          '</div>' +
          '<div class="fby-crosssell-info">' +
            '<div class="fby-crosssell-brand">' + escHtml(brandName) + '</div>' +
            '<div class="fby-crosssell-name">' + escHtml(product.title) + '</div>' +
            '<div class="fby-crosssell-price">' + CURRENCY_PREFIX + parseFloat(product.price).toFixed(2) + '</div>' +
          '</div>' +
          '<button type="button" class="fby-add-btn-sm fby-crosssell-add" data-fby-crosssell-add data-variant-id="' + escHtml(product.variantId) + '" data-fby-crosssell-handle="' + escAttr(product.handle || '') + '">Add to Cart</button>' +
        '</div>' +
        '<div class="fby-crosssell-msg" data-fby-crosssell-msg></div>';
    }

    // These "Complete the job" cross-sell products come from a static
    // per-bike table (brand, price, image, variant ID baked in from the
    // spreadsheet) rather than a live Shopify collection fetch like
    // Cleaning & Detailing — so unlike that section, nothing here notices
    // on its own when a product actually goes out of stock. Cached by
    // handle so a category with several rows of the same product (rare,
    // but the TWIN products can appear as both the primary pick and an
    // alt) only checks once.
    var crossSellStockCache = {};
    function checkCrossSellAvailability(handle){
      if (!handle) return Promise.resolve(true);
      if (crossSellStockCache.hasOwnProperty(handle)) return Promise.resolve(crossSellStockCache[handle]);
      return fetch('/products/' + handle + '.js')
        .then(function(r){ if (!r.ok) throw new Error('not found'); return r.json(); })
        .then(function(p){
          var available = !!(p.variants && p.variants[0] && p.variants[0].available);
          crossSellStockCache[handle] = available;
          return available;
        })
        .catch(function(){ return true; }); // fail open — a lookup hiccup shouldn't block a real sale
    }

    function markCrossSellOutOfStock(btn){
      var row = btn.closest('.fby-crosssell-row');
      var msgEl = row && row.nextElementSibling && row.nextElementSibling.hasAttribute('data-fby-crosssell-msg')
        ? row.nextElementSibling : null;
      btn.disabled = true;
      btn.textContent = 'Out of Stock';
      btn.classList.add('fby-add-btn-oos');
      btn.classList.remove('fby-added');
      if (msgEl) msgEl.textContent = 'Currently out of stock — check back soon, or try another brand below.';
    }

    function addCrossSellToCart(btn){
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var row = btn.closest('.fby-crosssell-row');
      var msgEl = row && row.nextElementSibling && row.nextElementSibling.hasAttribute('data-fby-crosssell-msg')
        ? row.nextElementSibling : null;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      }).then(function(r){
        if (!r.ok) return r.json().then(function(err){ throw err; });
        return r.json();
      }).then(function(){
        btn.disabled = false;
        btn.textContent = 'Added ✓';
        btn.classList.add('fby-added');
        if (msgEl) msgEl.innerHTML = '<a href="/cart">View cart</a>';
        notifyCartUpdated();
      }).catch(function(err){
        // Shopify's own /cart/add.js error for a sold-out or oversold
        // variant comes back as {status: 422, ...} with a description
        // like "Only 0 available" or "<title> is sold out". Anything
        // else (network blip, etc.) keeps the old generic retry copy.
        var isSoldOut = err && (err.status === 422 || /sold out|not enough|only \d+ available/i.test(err.message || err.description || ''));
        if (isSoldOut){
          markCrossSellOutOfStock(btn);
        } else {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
          if (msgEl) msgEl.textContent = 'Something went wrong — please try again.';
        }
      });
    }

    function wireCrossSellToggle(bodyEl){
      var toggleBtn = bodyEl.querySelector('[data-fby-crosssell-toggle]');
      var altsEl = bodyEl.querySelector('[data-fby-crosssell-alts]');
      if (toggleBtn && altsEl){
        toggleBtn.addEventListener('click', function(){
          var chev = toggleBtn.querySelector('[data-fby-crosssell-chev]');
          var isHidden = altsEl.hasAttribute('hidden');
          if (isHidden){
            altsEl.removeAttribute('hidden');
            if (chev) chev.textContent = '⌃';
          } else {
            altsEl.setAttribute('hidden', '');
            if (chev) chev.textContent = '⌄';
          }
        });
      }
    }

    function wireCrossSellAddButtons(bodyEl){
      bodyEl.querySelectorAll('[data-fby-crosssell-add]').forEach(function(btn){
        btn.addEventListener('click', function(){ addCrossSellToCart(btn); });
        // Proactively check stock as soon as the row renders, so a
        // customer sees "Out of Stock" up front rather than only finding
        // out after clicking Add to Cart and getting an error.
        var handle = btn.getAttribute('data-fby-crosssell-handle');
        if (handle){
          checkCrossSellAvailability(handle).then(function(available){
            if (!available) markCrossSellOutOfStock(btn);
          });
        }
      });
    }

    // Generic "one product per brand, primary + show-other-brands" renderer.
    // Takes a prebuilt table ({brandSlug: product}) rather than a category
    // key so callers can hand it a per-bike table (e.g. the TWIN-aware
    // transmission-oil table, or a fork-oil table built for the bike's own
    // weight spec) as easily as a static one.
    function renderCrossSellCategory(table, primarySlug, bodyEl){
      table = table || {};
      var primaryProduct = table[primarySlug];
      var others = CROSS_SELL_BRAND_ORDER.filter(function(s){ return s !== primarySlug && table[s]; });

      var html = '';
      if (primaryProduct){
        html += crossSellProductRow(primaryProduct, primarySlug, false);
        if (others.length){
          html += '<button type="button" class="fby-crosssell-toggle" data-fby-crosssell-toggle>Show other brands <span data-fby-crosssell-chev>⌄</span></button>';
        }
      } else {
        html += '<div class="fby-crosssell-gap">Not available from ' + escHtml(crossSellBrandName(primarySlug)) + '.</div>';
        if (others.length){
          html += '<button type="button" class="fby-crosssell-toggle" data-fby-crosssell-toggle>Show options <span data-fby-crosssell-chev>⌄</span></button>';
        }
      }

      if (others.length){
        html += '<div class="fby-crosssell-alts" data-fby-crosssell-alts hidden>';
        others.forEach(function(slug){
          html += crossSellProductRow(table[slug], slug, true);
        });
        html += '</div>';
      }

      bodyEl.innerHTML = html;
      wireCrossSellToggle(bodyEl);
      wireCrossSellAddButtons(bodyEl);
    }

    // TWIN-aware transmission/gear oil table for a given bike. The shop's
    // real Motul TWIN Gear 75W90 product is an exact spec match for the
    // TWIN-line bikes whose transmission calls for 75W-90 (6 Harley Big
    // Twin / Touring models). Four Softail models on the TWIN line spec
    // 80W-140 instead, and no real Motul product exists at that weight
    // (Motul's own 80W90/Gearbox products are out of stock, and nothing in
    // the catalog is 80W-140) — those 4 stay on the generic Motul
    // transmission fluid rather than show a wrong-viscosity "TWIN" product.
    // Flagged to Derek in the write-up rather than guessed around further.
    function transTableForBike(bike){
      var table = {};
      var base = CROSS_SELL_PRODUCTS.trans || {};
      for (var k in base){ if (base.hasOwnProperty(k)) table[k] = base[k]; }
      if (bike.oilProductHandle === TWIN_ENGINE_OIL_HANDLE && bike.transmissionOil === '75W-90'){
        table.motul = TWIN_GEAR_OIL_PRODUCT;
      }
      return table;
    }

    // Fork-oil table for a given bike: only brands with a product at this
    // bike's EXACT fork-oil weight are included (see FORK_OIL_PRODUCTS
    // comment above) — deliberately no nearest-weight fallback.
    function forkOilTableForBike(bike){
      var weight = (bike.forkOil || '').trim();
      var table = {};
      if (!weight || isNA(weight)) return table;
      CROSS_SELL_BRAND_ORDER.forEach(function(slug){
        var byWeight = FORK_OIL_PRODUCTS[slug];
        if (byWeight && byWeight[weight]) table[slug] = byWeight[weight];
      });
      return table;
    }

    // Primary (chaincase) oil card. The Motul TWIN product is the specialty
    // item purpose-built for the TWIN-line Big Twin/Sportster application
    // and stays the primary pick regardless of which brand the bike's main
    // engine oil is currently on (it's a fixed exception to the brand-swap
    // logic — see the comment in selectBrand). Maxima's V-Twin Synthetic
    // Primary Oil (SKU 3603-0043) was added 2026-09-16 as a real "Show other
    // brands" fallback after the Motul product went out of stock on a real
    // customer's bike — previously there was no alternate at all here, which
    // meant an out-of-stock Motul product was a genuine dead end.
    // Shown only when the bike's own "Primary" spec (bike.chaindriveOil) is
    // populated — currently the 10 TWIN bikes that have a wet primary case.
    function renderPrimaryOilCard(grid, bike){
      var cardEl = grid.querySelector('[data-fby-crosssell="primary"]');
      if (!cardEl) return;
      var applicable = !isNA(bike.chaindriveOil);
      cardEl.hidden = !applicable;
      if (!applicable) return;
      var bodyEl = cardEl.querySelector('[data-fby-crosssell-body]');
      if (!bodyEl) return;
      var table = { motul: TWIN_PRIMARY_OIL_PRODUCT, maxima: MAXIMA_PRIMARY_OIL_PRODUCT };
      renderCrossSellCategory(table, 'motul', bodyEl);
      var noteEl = capacityNoteEl('primary oil', bike.chaindriveCapacityL);
      if (noteEl) bodyEl.insertBefore(noteEl, bodyEl.firstChild);
    }

    // Fork-oil card — brand + weight matched, hidden entirely when the bike
    // has no fork-oil spec at all (e.g. N/A on the sheet).
    //
    // Note: frontForkCapacityL is NOT used here for a per-bike number. It's
    // a constant "1.5" across nearly every bike in the sheet (110/112) —
    // confirmed with Derek this isn't real per-bike data but a midpoint
    // stocking estimate. Rather than show a precise-looking (and likely
    // wrong) liter figure, we show a generic rule-of-thumb range instead,
    // per Derek's own shop experience: most bikes take 1-2L total.
    function renderForkOilCard(grid, bike, primarySlug){
      var cardEl = grid.querySelector('[data-fby-crosssell="fork"]');
      if (!cardEl) return;
      var weight = (bike.forkOil || '').trim();
      var applicable = weight && !isNA(weight);
      cardEl.hidden = !applicable;
      if (!applicable) return;
      var bodyEl = cardEl.querySelector('[data-fby-crosssell-body]');
      if (!bodyEl) return;
      renderCrossSellCategory(forkOilTableForBike(bike), primarySlug, bodyEl);
      var noteEl = document.createElement('div');
      noteEl.className = 'fby-crosssell-capacity-note';
      noteEl.textContent = "Most bikes take 1-2L of fork oil in total — check your owner's manual for the exact amount per leg.";
      bodyEl.insertBefore(noteEl, bodyEl.firstChild);
    }

    // Coolant card — shown only for liquid-cooled bikes (isLiquidCooledBike
    // reads Nicole's coolingSystemCapacityL field, which already marks
    // air-cooled bikes as N/A / "N/A (air-cooled)" — no new sheet column
    // needed). Only Motorex and Maxima carry a real coolant product in the
    // catalog today, so the other three brands fall back to the normal
    // "Not available — Show options" path via renderCrossSellCategory.
    function renderCoolantCard(grid, bike, primarySlug){
      var cardEl = grid.querySelector('[data-fby-crosssell="coolant"]');
      if (!cardEl) return;
      var applicable = isLiquidCooledBike(bike);
      cardEl.hidden = !applicable;
      if (!applicable) return;
      var bodyEl = cardEl.querySelector('[data-fby-crosssell-body]');
      if (!bodyEl) return;
      renderCrossSellCategory(COOLANT_PRODUCTS, primarySlug, bodyEl);
      var noteEl = capacityNoteEl('coolant', bike.coolingSystemCapacityL);
      if (noteEl) bodyEl.insertBefore(noteEl, bodyEl.firstChild);
    }

    // Chain-care cleaner+lube pair for one brand slug — used both for the
    // primary brand and for each "other brand" alternate. isOffRoad picks
    // between a brand's road/off-road lube where the catalog has both.
    function chainCareRowsHtml(brandSlug, isAlt, isOffRoad){
      var lube = resolveChainLube(brandSlug, isOffRoad);
      if (!lube) return '';
      var cleaner = CHAIN_CLEANER_PRODUCTS[brandSlug];
      var html = '<div class="fby-crosssell-pair">';
      if (cleaner) html += crossSellProductRow(cleaner, brandSlug, isAlt);
      html += crossSellProductRow(lube, brandSlug, isAlt);
      html += '</div>';
      return html;
    }

    function renderChainCareCategory(primarySlug, bodyEl, isOffRoad){
      var hasPrimary = !!CROSS_SELL_PRODUCTS.chain[primarySlug];
      var others = CROSS_SELL_BRAND_ORDER.filter(function(s){ return s !== primarySlug && CROSS_SELL_PRODUCTS.chain[s]; });

      var html = '';
      if (hasPrimary){
        html += chainCareRowsHtml(primarySlug, false, isOffRoad);
        if (others.length){
          html += '<button type="button" class="fby-crosssell-toggle" data-fby-crosssell-toggle>Show other brands <span data-fby-crosssell-chev>⌄</span></button>';
        }
      } else {
        html += '<div class="fby-crosssell-gap">Not available from ' + escHtml(crossSellBrandName(primarySlug)) + '.</div>';
        if (others.length){
          html += '<button type="button" class="fby-crosssell-toggle" data-fby-crosssell-toggle>Show options <span data-fby-crosssell-chev>⌄</span></button>';
        }
      }

      if (others.length){
        html += '<div class="fby-crosssell-alts" data-fby-crosssell-alts hidden>';
        others.forEach(function(slug){ html += chainCareRowsHtml(slug, true, isOffRoad); });
        html += '</div>';
      }

      bodyEl.innerHTML = html;
      wireCrossSellToggle(bodyEl);
      wireCrossSellAddButtons(bodyEl);
    }

    // Drive-system-aware "Chain Care" / "Shaft Drive Oil" card. Chain-drive
    // bikes get a cleaner + lube pair per brand (as above); shaft-drive
    // bikes get the one real shaft-drive gear oil in the catalog; belt
    // (and belt-trike) bikes get nothing here — belts don't use either.
    function renderDriveSystemCard(grid, bike, primarySlug){
      var cardEl = grid.querySelector('[data-fby-crosssell="chain"]');
      if (!cardEl) return;
      var titleEl = cardEl.querySelector('.fby-crosssell-title');
      var bodyEl = cardEl.querySelector('[data-fby-crosssell-body]');
      var drive = (bike.driveSystem || '').trim();

      if (!drive || /^belt/i.test(drive)){
        cardEl.hidden = true;
        return;
      }
      cardEl.hidden = false;

      if (/^shaft/i.test(drive)){
        if (titleEl) titleEl.textContent = CROSS_SELL_LABELS.shaft;
        if (bodyEl){
          bodyEl.innerHTML = crossSellProductRow(SHAFT_DRIVE_OIL_PRODUCT, 'maxima', false);
          wireCrossSellAddButtons(bodyEl);
          // capacityNoteEl's strict numeric check means the one bike whose
          // shaftDriveCapacityL is "75W-90" (a viscosity spec copy-pasted
          // into the capacity column, not a liter value — flagged to
          // Derek/Nicole) correctly gets no note instead of a false "75L".
          var shaftNoteEl = capacityNoteEl('shaft drive oil', bike.shaftDriveCapacityL);
          if (shaftNoteEl) bodyEl.insertBefore(shaftNoteEl, bodyEl.firstChild);
        }
        return;
      }

      // Chain drive (the default/fallback for any other value)
      if (titleEl) titleEl.textContent = CROSS_SELL_LABELS.chain;
      if (bodyEl) renderChainCareCategory(primarySlug, bodyEl, isOffRoadBike(bike));
    }

    function renderCrossSell(bike){
      var grid = root.querySelector('[data-fby-crosssell-grid]');
      if (!grid || !bike) return;
      // Follow whichever brand is currently selected as the primary oil
      // (state.oil is set by selectBrand — including after an "Also
      // compatible" swap), so "Complete the job" switches brands along
      // with the oil. Falls back to the bike's static sheet-defined
      // primary brand before any selection has happened (e.g. electric
      // bikes, where oil doesn't apply and state.oil stays null).
      var primarySlug = (state.oil && state.oil.brandSlug) || bike.primaryBrandSlug;

      // Brake fluid and transmission/gear oil: always shown, one product
      // per brand (trans uses a per-bike table so TWIN-line bikes can pick
      // up the real Motul TWIN Gear product — see transTableForBike).
      CROSS_SELL_ORDER.forEach(function(cat){
        var cardEl = grid.querySelector('[data-fby-crosssell="' + cat + '"]');
        if (!cardEl) return;
        var bodyEl = cardEl.querySelector('[data-fby-crosssell-body]');
        var table = cat === 'trans' ? transTableForBike(bike) : CROSS_SELL_PRODUCTS[cat];
        if (bodyEl) renderCrossSellCategory(table, primarySlug, bodyEl);

        // Show how much transmission/gear oil the bike actually takes,
        // straight from Nicole's data (bike.transmissionCapacityL) — shown
        // for every bike with a real number here, not just two-strokes (it
        // used to be two-stroke-only, back when this was mislabeled as the
        // engine-oil capacity up top — see the mix-ratio copy in
        // selectBrand()). Bikes with no transmission-oil spec (N/A) get no
        // note, same as before.
        if (cat === 'trans' && bodyEl){
          var transNoteEl = capacityNoteEl('transmission oil', bike.transmissionCapacityL);
          if (transNoteEl) bodyEl.insertBefore(transNoteEl, bodyEl.firstChild);
        }
      });

      // Primary oil, fork oil, coolant, and the drive-system-aware
      // chain/shaft card each gate on the bike's own data and are hidden
      // entirely when not applicable to the selected bike.
      renderPrimaryOilCard(grid, bike);
      renderForkOilCard(grid, bike, primarySlug);
      renderCoolantCard(grid, bike, primarySlug);
      renderDriveSystemCard(grid, bike, primarySlug);
    }

    function updateFilterPrice(){
      var price = parseFloat((state.selected && state.selected.oilFilterPrice) || '0');
      var total = (price * state.filterQty).toFixed(2);
      root.querySelector('[data-fby-filter-price]').textContent = CURRENCY_PREFIX + total;
    }

    function changeQty(delta){
      state.filterQty = Math.max(1, Math.min(24, state.filterQty + delta));
      root.querySelector('[data-fby-qty-num]').textContent = String(state.filterQty);
      updateFilterPrice();
      syncKitSliderFromManualEdit();
    }

    // ---- Case-pricing live discount preview ----
    // Mirrors the real, live "Case Pricing" automatic Shopify discounts
    // (assets/flybyu-case-pricing.js) so the kit slider and manual qty
    // steppers show the actual tier discount in real time, without an app.
    function isOilCasePricingEligible(){
      return !!(state.oil && window.FlybyuCasePricing && window.FlybyuCasePricing.isEligible(state.oil.variantId));
    }

    function getOilTier(){
      if (!isOilCasePricingEligible()) return null;
      return window.FlybyuCasePricing.getTier(state.oil.qty);
    }

    function getOilNextTier(){
      if (!isOilCasePricingEligible()) return null;
      return window.FlybyuCasePricing.nextTier(state.oil.qty);
    }

    function updateOilPrice(){
      if (!state.oil) return;
      var price = parseFloat(state.oil.price || '0');
      var qty = state.oil.qty;
      var originalTotal = price * qty;

      var badgeEl = root.querySelector('[data-fby-oil-discount-badge]');
      var origEl = root.querySelector('[data-fby-oil-original-price]');
      var totalEl = root.querySelector('[data-fby-oil-total-price]');
      var savingsEl = root.querySelector('[data-fby-oil-savings]');
      var nudgeEl = root.querySelector('[data-fby-oil-nudge]');

      var tier = getOilTier();

      if (tier){
        var discountedTotal = originalTotal * (1 - tier.pct);
        var savings = originalTotal - discountedTotal;
        if (badgeEl){ badgeEl.textContent = Math.round(tier.pct * 100) + '% OFF'; badgeEl.style.display = ''; }
        if (origEl){ origEl.textContent = CURRENCY_PREFIX + originalTotal.toFixed(2); origEl.style.display = ''; }
        if (totalEl) totalEl.textContent = CURRENCY_PREFIX + discountedTotal.toFixed(2);
        if (savingsEl){ savingsEl.textContent = 'You save ' + CURRENCY_PREFIX + savings.toFixed(2); savingsEl.style.display = ''; }
      } else {
        if (badgeEl) badgeEl.style.display = 'none';
        if (origEl) origEl.style.display = 'none';
        if (totalEl) totalEl.textContent = CURRENCY_PREFIX + originalTotal.toFixed(2);
        if (savingsEl) savingsEl.style.display = 'none';
      }

      if (nudgeEl){
        var next = getOilNextTier();
        var needed = next ? (next.qty - qty) : 0;
        if (next && needed > 0){
          nudgeEl.textContent = 'Add ' + needed + ' more to save ' + Math.round(next.pct * 100) + '%';
          nudgeEl.style.display = '';
        } else {
          nudgeEl.style.display = 'none';
        }
      }

      // Keep the bold "your bike + oil" summary at the top of the results
      // in sync with whatever oil/quantity is currently selected.
      var ctxOilEl = root.querySelector('[data-fby-ctx-oil]');
      if (ctxOilEl && state.selected){
        var bikeForCtx = state.selected;
        var viscosityForCtx = extractViscosity(state.oil.variantTitle) || bikeForCtx.viscosity || '';
        var gradeViscosity = [displayGradeFor(bikeForCtx, state.oil), viscosityForCtx].filter(Boolean).join(' ');
        var brandForCtx = BRANDS[state.oil.brandSlug] || { name: bikeForCtx.primaryBrand };
        var qtyTextForCtx = qty + ' bottle' + (qty === 1 ? '' : 's');
        // Two-stroke bikes: oilCapacityLNum isn't a real sump size for these
        // (see isTwoStrokeBike) — the mix-ratio copy above the oil card
        // already covers this, so suppress it here rather than repeat the
        // same borrowed transmission-oil number in the summary bar.
        var capTextForCtx = (!isTwoStrokeBike(bikeForCtx) && bikeForCtx.oilCapacityLNum) ? (' (' + bikeForCtx.oilCapacityLNum + 'L)') : '';
        ctxOilEl.textContent = [brandForCtx.name, gradeViscosity].filter(Boolean).join(' ') + ' · ' + qtyTextForCtx + capTextForCtx;
      }
    }

    function changeOilQty(delta){
      if (!state.oil) return;
      state.oil.qty = Math.max(1, Math.min(48, state.oil.qty + delta));
      root.querySelector('[data-fby-oil-qty-num]').textContent = String(state.oil.qty);
      updateOilPrice();
      syncKitSliderFromManualEdit();
    }

    function addOilToCart(btn){
      if (!state.oil) return;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(state.oil.variantId, 10), quantity: state.oil.qty }] })
      }).then(function(r){
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function(){
        btn.disabled = false;
        btn.textContent = 'Added to Cart ✓';
        btn.classList.add('fby-added');
        root.querySelector('[data-fby-oil-add-msg]').innerHTML = '<a href="/cart">View cart</a>';
        notifyCartUpdated();
      }).catch(function(){
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
        root.querySelector('[data-fby-oil-add-msg]').textContent = 'Something went wrong — please try again.';
      });
    }

    function addFilterToCart(btn){
      var bike = state.selected;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(bike.oilFilterVariantId, 10), quantity: state.filterQty }] })
      }).then(function(r){
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function(){
        btn.disabled = false;
        btn.textContent = 'Added to Cart ✓';
        btn.classList.add('fby-added');
        root.querySelector('[data-fby-add-msg]').innerHTML = '<a href="/cart">View cart</a>';
        notifyCartUpdated();
      }).catch(function(){
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
        root.querySelector('[data-fby-add-msg]').textContent = 'Something went wrong — please try again.';
      });
    }

    // ---- Oil-change package option (combo card) ----

    // Also fills in the "how many / what viscosity / what size / what filter"
    // caption under each photo, so the package summary never leaves the
    // customer guessing whether they have the right amount or the right
    // part — this is deliberately redundant with the qty/price rows below it.
    function getKitButtonLabel(){
      return 'Add Oil Change Package(s) to Cart';
    }

    // Each product now has its own photo inside its own rectangle (rather
    // than a shared strip above the card), and that rectangle's own
    // show/hide (oilSection / filter-available, both already driven by
    // renderResults) is what keeps a stale photo from a previously-viewed
    // bike from lingering — so this just needs to keep the <img> src
    // current, nothing more.
    function updateKitHeaderPhotos(){
      var oilImg = root.querySelector('[data-fby-oil-photo-lg]');
      var filterImg = root.querySelector('[data-fby-filter-photo-lg]');
      var bike = state.selected;
      var hasOil = !!(state.oil && state.oil.image);
      var hasFilter = !!(bike && bike.oilFilterImage && state.filterAvailable);

      if (oilImg) oilImg.src = hasOil ? state.oil.image : '';
      if (filterImg) filterImg.src = hasFilter ? bike.oilFilterImage : '';
    }

    // The package option (with its "Add Oil Change Package(s) to Cart"
    // button and the "Or buy separately" divider) only makes sense when
    // BOTH oil and a filter are available for this bike — otherwise
    // there's nothing to bundle, and the customer just uses the single
    // "Just the Oil" or "Just the Filter(s)" row on its own. The quantity
    // picker above it is shown whenever either oil or a filter is
    // available, since it drives both.
    function updatePackageVisibility(){
      var hasOil = !!state.oil;
      var hasFilter = !!state.filterAvailable;
      var showPackage = hasOil && hasFilter;
      var pkgEl = root.querySelector('[data-fby-package-option]');
      var qtySelectEl = root.querySelector('[data-fby-qty-select]');
      if (pkgEl) pkgEl.style.display = showPackage ? '' : 'none';
      if (qtySelectEl) qtySelectEl.style.display = (hasOil || hasFilter) ? '' : 'none';
    }

    // Package price = the oil's case-pricing-discounted total (the only
    // part of this bundle that's ever actually discounted) plus the
    // filter's full, undiscounted total — never implying a discount on the
    // filter portion, since none of our case-pricing discounts apply to
    // filters.
    function updatePackagePrice(){
      var badgeEl = root.querySelector('[data-fby-kit-discount]');
      var origEl = root.querySelector('[data-fby-kit-original-price]');
      var totalEl = root.querySelector('[data-fby-kit-total-price]');
      var savingsEl = root.querySelector('[data-fby-kit-savings]');
      var nudgeEl = root.querySelector('[data-fby-kit-nudge]');
      if (!totalEl) return;
      if (!state.oil || !state.filterAvailable) return;

      var oilOriginal = parseFloat(state.oil.price || '0') * state.oil.qty;
      var filterTotal = parseFloat((state.selected && state.selected.oilFilterPrice) || '0') * state.filterQty;
      var tier = getOilTier();

      if (tier){
        var oilDiscounted = oilOriginal * (1 - tier.pct);
        var savings = oilOriginal - oilDiscounted;
        if (badgeEl){ badgeEl.textContent = Math.round(tier.pct * 100) + '% OFF OIL'; badgeEl.style.display = ''; }
        if (origEl){ origEl.textContent = CURRENCY_PREFIX + (oilOriginal + filterTotal).toFixed(2); origEl.style.display = ''; }
        totalEl.textContent = CURRENCY_PREFIX + (oilDiscounted + filterTotal).toFixed(2);
        if (savingsEl){ savingsEl.textContent = 'You save ' + CURRENCY_PREFIX + savings.toFixed(2) + ' on the oil'; savingsEl.style.display = ''; }
      } else {
        if (badgeEl) badgeEl.style.display = 'none';
        if (origEl) origEl.style.display = 'none';
        totalEl.textContent = CURRENCY_PREFIX + (oilOriginal + filterTotal).toFixed(2);
        if (savingsEl) savingsEl.style.display = 'none';
      }

      if (nudgeEl){
        var next = getOilNextTier();
        var needed = next ? (next.qty - state.oil.qty) : 0;
        if (next && needed > 0){
          nudgeEl.textContent = 'Add ' + needed + ' more bottle' + (needed === 1 ? '' : 's') + ' of oil to save ' + Math.round(next.pct * 100) + '%';
          nudgeEl.style.display = '';
        } else {
          nudgeEl.style.display = 'none';
        }
      }
    }

    function updateQtyChoiceButtons(){
      root.querySelectorAll('[data-fby-qty-choice]').forEach(function(btn){
        var val = parseInt(btn.getAttribute('data-fby-qty-choice'), 10);
        btn.classList.toggle('fby-qty-choice-active', val === state.kitMultiplier);
      });
    }

    function initKitSlider(){
      if (!state.oil && !state.filterAvailable){
        var qtySelectEl0 = root.querySelector('[data-fby-qty-select]');
        var pkgEl0 = root.querySelector('[data-fby-package-option]');
        if (qtySelectEl0) qtySelectEl0.style.display = 'none';
        if (pkgEl0) pkgEl0.style.display = 'none';
        // Reset the product photos too — otherwise a stale oil bottle or
        // filter photo from the previously-selected bike (e.g. switching
        // from a petrol bike to an electric one that has neither) is left
        // showing. (In practice the oil/filter rectangles are already
        // hidden via their own display toggles in this state, but this
        // keeps the <img> src itself from going stale underneath.)
        updateKitHeaderPhotos();
        return;
      }
      state.kitMultiplier = 1;
      updateKitHeaderPhotos();

      var addBtn = root.querySelector('[data-fby-kit-add-btn]');
      if (addBtn){
        addBtn.textContent = getKitButtonLabel();
        addBtn.disabled = false;
        addBtn.classList.remove('fby-added');
        addBtn.onclick = function(){ addKitToCart(addBtn); };
      }
      var msgEl = root.querySelector('[data-fby-kit-add-msg]');
      if (msgEl) msgEl.textContent = '';

      updateQtyChoiceButtons();
      updateKitSummary();

      root.querySelectorAll('[data-fby-qty-choice]').forEach(function(btn){
        btn.onclick = function(){
          applyKitMultiplier(parseInt(btn.getAttribute('data-fby-qty-choice'), 10) || 1);
        };
      });
    }

    // The bottle count for a SINGLE oil change is rounded up to a whole bottle
    // (e.g. a 1.2L bike with 1L bottles suggests 2). If the kit picker just
    // multiplied that already-rounded number by the number of oil changes,
    // the rounding compounds — 2 oil changes would show 4 bottles when the
    // bike only actually needs 3 (1.2L × 2 = 2.4L → 3 bottles). Instead,
    // recompute the total volume needed for N oil changes and round ONCE
    // against that, so the picker never oversells bottles. This doesn't
    // affect the case-pricing tiers (3+/6+/12+ bottles) — they still just
    // read whatever quantity ends up in the cart.
    function computeNeededOilQty(multiplier){
      if (!state.oil) return null;
      var bike = state.selected;
      var bottleSize = state.oil.bottleSizeL || 1;
      if (bike && bike.oilCapacityLNum){
        return Math.max(1, Math.ceil((bike.oilCapacityLNum * multiplier) / bottleSize));
      }
      return Math.max(1, (state.oil.suggestedQty || 1) * multiplier);
    }

    function applyKitMultiplier(multiplier){
      multiplier = Math.max(1, Math.min(MAX_KIT_MULTIPLIER, multiplier));
      state.kitMultiplier = multiplier;

      if (state.oil){
        state.oil.qty = Math.min(48, computeNeededOilQty(multiplier));
        var oilQtyNumEl = root.querySelector('[data-fby-oil-qty-num]');
        if (oilQtyNumEl) oilQtyNumEl.textContent = String(state.oil.qty);
        updateOilPrice();
      }
      if (state.filterAvailable){
        state.filterQty = Math.max(1, Math.min(24, multiplier));
        var filterQtyNumEl = root.querySelector('[data-fby-qty-num]');
        if (filterQtyNumEl) filterQtyNumEl.textContent = String(state.filterQty);
        updateFilterPrice();
      }
      updateQtyChoiceButtons();
      updateKitSummary();
    }

    // If the shopper fine-tunes one of the individual +/- steppers by hand,
    // the two quantities are no longer necessarily a clean multiple of each
    // other — reflect that in the summary text (and clear the active
    // quantity button) rather than silently overwriting their manual choice.
    function syncKitSliderFromManualEdit(){
      var summary = root.querySelector('[data-fby-kit-summary]');
      if (!summary || !state.selected) return;
      var matchedMultiplier = null;
      for (var m = 1; m <= MAX_KIT_MULTIPLIER; m++){
        var oilMatches = state.oil ? (state.oil.qty === computeNeededOilQty(m)) : true;
        var filterMatches = state.filterAvailable ? (state.filterQty === m) : true;
        if (oilMatches && filterMatches){ matchedMultiplier = m; break; }
      }
      if (matchedMultiplier){
        state.kitMultiplier = matchedMultiplier;
        updateQtyChoiceButtons();
        updateKitSummary();
      } else {
        state.kitMultiplier = 0;
        updateQtyChoiceButtons();
        summary.textContent = buildSummaryText(true);
        updateKitHeaderPhotos();
        updatePackageVisibility();
        updatePackagePrice();
      }
    }

    function buildSummaryText(custom){
      var parts = [];
      if (state.oil){
        parts.push(state.oil.qty + ' bottle' + (state.oil.qty === 1 ? '' : 's') + ' of oil');
      }
      if (state.filterAvailable){
        parts.push(state.filterQty + ' filter' + (state.filterQty === 1 ? '' : 's'));
      }
      var prefix = custom ? 'Custom: ' : (state.kitMultiplier + ' oil change' + (state.kitMultiplier === 1 ? '' : 's') + ' = ');
      return prefix + parts.join(' + ');
    }

    function updateKitSummary(){
      var summary = root.querySelector('[data-fby-kit-summary]');
      if (summary) summary.textContent = buildSummaryText(false);
      updateKitHeaderPhotos();
      updatePackageVisibility();
      updatePackagePrice();
    }

    function addKitToCart(btn){
      var items = [];
      if (state.oil){
        items.push({ id: parseInt(state.oil.variantId, 10), quantity: state.oil.qty });
      }
      if (state.filterAvailable){
        items.push({ id: parseInt(state.selected.oilFilterVariantId, 10), quantity: state.filterQty });
      }
      if (!items.length) return;

      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function(r){
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function(){
        btn.disabled = false;
        btn.textContent = 'Added to Cart ✓';
        btn.classList.add('fby-added');
        root.querySelector('[data-fby-kit-add-msg]').innerHTML = '<a href="/cart">View cart</a>';
        if (state.oil){
          var oilBtn = root.querySelector('[data-fby-oil-add-btn]');
          oilBtn.textContent = 'Added to Cart ✓';
          oilBtn.classList.add('fby-added');
        }
        if (state.filterAvailable){
          var filterBtn = root.querySelector('[data-fby-add-btn]');
          filterBtn.textContent = 'Added to Cart ✓';
          filterBtn.classList.add('fby-added');
        }
        notifyCartUpdated();
      }).catch(function(){
        btn.disabled = false;
        btn.textContent = getKitButtonLabel();
        root.querySelector('[data-fby-kit-add-msg]').textContent = 'Something went wrong — please try again.';
      });
    }

    // Why-this-brand toggle
    root.querySelector('[data-fby-why-toggle]').addEventListener('click', function(){
      var chev = root.querySelector('[data-fby-why-chev]');
      var body = root.querySelector('[data-fby-why-body]');
      var open = body.classList.toggle('fby-open');
      chev.classList.toggle('fby-open', open);
    });

    // "What's the difference?" oil-grade explainer toggle (2026-09-16) —
    // same expand/collapse pattern as the "Why [Brand]?" toggle above.
    var gradeHelpToggle = root.querySelector('[data-fby-grade-help-toggle]');
    if (gradeHelpToggle){
      gradeHelpToggle.addEventListener('click', function(){
        var chev = root.querySelector('[data-fby-grade-help-chev]');
        var body = root.querySelector('[data-fby-grade-help-body]');
        var open = body.classList.toggle('fby-open');
        chev.classList.toggle('fby-open', open);
      });
    }

    // ---- Cleaning & Detailing accordion (2026-09-16) ----
    // Unlike "Complete the job" above, these 9 categories aren't bike-
    // specific and aren't hand-curated per brand — they mirror the same
    // "Clean and Shine Products" categories from the site's own mega menu,
    // each backed by a real Shopify collection (see the data-fby-clean-
    // handle on each category card in the liquid). Rather than hardcoding
    // a second product catalog here (which would drift out of sync with
    // whatever Derek adds/removes in Shopify), each category's product
    // list is fetched live from that collection's own product-listing
    // endpoint the first time it's expanded, then cached in memory so
    // re-opening it doesn't refetch. True accordion: opening one category
    // closes any other that's open, so the page doesn't grow unbounded if
    // a customer clicks through several.
    var cleanCategoryCache = {};

    function fetchCleanCategoryProducts(handle){
      if (cleanCategoryCache[handle]) return Promise.resolve(cleanCategoryCache[handle]);
      return fetch('/collections/' + handle + '/products.json?limit=250')
        .then(function(r){ if (!r.ok) throw new Error('not ok'); return r.json(); })
        .then(function(data){
          var products = (data && data.products) || [];
          cleanCategoryCache[handle] = products;
          return products;
        });
    }

    // One row per product. Single-variant products (the large majority)
    // get a direct "Add to Cart" button, same as the "Complete the job"
    // rows. Products sold in more than one size/case quantity (e.g. Maxima
    // Bio Wash: 946ml or an 18.9L pail) instead get a "Select Size" button
    // that opens the shared product modal with a size picker + its own Add
    // to Cart, so a customer can't accidentally buy the wrong size in one
    // click. Out-of-stock single-variant products show a disabled state
    // instead of a button that would just fail at checkout.
    //
    // Brand label (added 2026-09-16, per Derek): most product titles in
    // these 3 accordions don't include the brand ("BIKE PROTECT", "CHAIN
    // WAX"), so it wasn't obvious at a glance who makes what. Rather than
    // waiting on a title-naming standard across the catalog, this pulls
    // the brand straight from the product's real Shopify `vendor` field —
    // live data, not something we maintain — and shows it as a small grey
    // label above the title, matching the same treatment already used for
    // the "Complete the job" cross-sell rows (.fby-crosssell-brand).
    // Vendor strings come back in whatever casing the feed uses ("MUC-OFF",
    // "MAXIMA RACING OIL", "KLOTZ OIL") — normalized here to the same
    // display names used everywhere else on this page. A title that
    // already leads with its brand ("Maxima Bio Wash", "Motorex Moto
    // Clean") skips the label so it isn't shown twice. A vendor value that
    // isn't a real brand at all — 2 products currently have `vendor` set
    // to "Flybyu Motorsports" by mistake instead of the actual maker —
    // falls through to no label rather than showing something misleading;
    // worth Derek/Nicole fixing at the source when convenient, not
    // urgent since it just means those 2 rows show no label for now.
    var VENDOR_DISPLAY = {
      'muc-off': 'Muc-Off',
      'motorex': 'Motorex',
      'motul': 'Motul',
      'klotz oil': 'Klotz',
      'klotz': 'Klotz',
      'maxima racing oil': 'Maxima',
      'maxima': 'Maxima',
      'liqui moly': 'Liqui Moly'
    };
    var BRAND_TITLE_PREFIXES = ['Liqui Moly', 'Muc-Off', 'Motorex', 'Maxima', 'Klotz', 'Motul'];

    function cleanBrandLabel(vendor, title){
      var titleStr = String(title || '').trim().toLowerCase();
      var alreadyLeadsWithBrand = BRAND_TITLE_PREFIXES.some(function(p){
        return titleStr.indexOf(p.toLowerCase()) === 0;
      });
      if (alreadyLeadsWithBrand) return '';
      return VENDOR_DISPLAY[String(vendor || '').trim().toLowerCase()] || '';
    }

    function cleanProductRow(product){
      var rawVariants = product.variants || [];
      if (!rawVariants.length) return '';
      var variants = rawVariants.map(function(v){
        return { id: String(v.id), title: v.title, price: String(v.price), available: v.available !== false };
      });
      var image = (product.images && product.images[0] && product.images[0].src) || '';
      var singleVariant = variants.length <= 1;
      var firstVariant = variants[0];
      var priceLabel;
      if (singleVariant){
        priceLabel = CURRENCY_PREFIX + parseFloat(firstVariant.price).toFixed(2);
      } else {
        var prices = variants.map(function(v){ return parseFloat(v.price); });
        priceLabel = 'From ' + CURRENCY_PREFIX + Math.min.apply(null, prices).toFixed(2);
      }
      var modalAttrs = '' +
        ' data-fby-modal-open="clean"' +
        ' data-fby-modal-title="' + escAttr(product.title) + '"' +
        ' data-fby-modal-price="' + escAttr(firstVariant.price) + '"' +
        ' data-fby-modal-image="' + escAttr(image) + '"' +
        ' data-fby-modal-handle="' + escAttr(product.handle || '') + '"' +
        (singleVariant
          ? ' data-fby-modal-variant-id="' + escAttr(firstVariant.id) + '"'
          : ' data-fby-modal-variants="' + escAttr(JSON.stringify(variants)) + '"');
      var actionHtml;
      if (singleVariant){
        actionHtml = firstVariant.available
          ? '<button type="button" class="fby-add-btn-sm fby-clean-add" data-fby-clean-add data-variant-id="' + escHtml(firstVariant.id) + '">Add to Cart</button>'
          : '<button type="button" class="fby-add-btn-sm fby-add-btn-oos" disabled>Out of Stock</button>';
      } else {
        actionHtml = '<button type="button" class="fby-add-btn-sm fby-clean-select"' + modalAttrs + '>Select Size</button>';
      }
      var brandLabel = cleanBrandLabel(product.vendor, product.title);
      return '' +
        '<div class="fby-clean-row">' +
          '<div class="fby-clean-photo-col fby-clickable"' + modalAttrs + '>' +
            '<img class="fby-clean-photo" src="' + escHtml(image) + '" alt="">' +
          '</div>' +
          '<div class="fby-clean-info">' +
            (brandLabel ? '<div class="fby-clean-brand">' + escHtml(brandLabel) + '</div>' : '') +
            '<div class="fby-clean-name">' + escHtml(product.title) + '</div>' +
            '<div class="fby-clean-price">' + priceLabel + '</div>' +
          '</div>' +
          actionHtml +
        '</div>' +
        '<div class="fby-clean-msg" data-fby-clean-msg></div>';
    }

    function addCleanToCart(btn){
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var row = btn.closest('.fby-clean-row');
      var msgEl = row && row.nextElementSibling && row.nextElementSibling.hasAttribute('data-fby-clean-msg')
        ? row.nextElementSibling : null;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      }).then(function(r){
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function(){
        btn.disabled = false;
        btn.textContent = 'Added ✓';
        btn.classList.add('fby-added');
        if (msgEl) msgEl.innerHTML = '<a href="/cart">View cart</a>';
        notifyCartUpdated();
      }).catch(function(){
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
        if (msgEl) msgEl.textContent = 'Something went wrong — please try again.';
      });
    }

    function wireCleanAddButtons(bodyEl){
      bodyEl.querySelectorAll('[data-fby-clean-add]').forEach(function(btn){
        btn.addEventListener('click', function(){ addCleanToCart(btn); });
      });
    }

    function renderCleanCategoryBody(handle, bodyEl){
      bodyEl.innerHTML = '<div class="fby-clean-loading">Loading…</div>';
      fetchCleanCategoryProducts(handle).then(function(products){
        if (!products.length){
          bodyEl.innerHTML = '<div class="fby-clean-empty">Nothing here yet.</div>';
          return;
        }
        bodyEl.innerHTML = products.map(cleanProductRow).join('');
        wireCleanAddButtons(bodyEl);
      }).catch(function(){
        bodyEl.innerHTML = '<div class="fby-clean-empty">Couldn’t load these right now — please try again.</div>';
      });
    }

    function wireCleanAccordion(){
      var cards = root.querySelectorAll('[data-fby-clean-card]');
      var loadedHandles = {};
      cards.forEach(function(card){
        var toggleBtn = card.querySelector('[data-fby-clean-toggle]');
        var bodyEl = card.querySelector('[data-fby-clean-body]');
        var chev = card.querySelector('[data-fby-clean-chev]');
        var handle = card.getAttribute('data-fby-clean-handle');
        if (!toggleBtn || !bodyEl || !handle) return;
        toggleBtn.addEventListener('click', function(){
          var isOpen = card.classList.contains('fby-clean-open');
          // True accordion — close every other open category first.
          cards.forEach(function(other){
            if (other === card) return;
            other.classList.remove('fby-clean-open');
            var otherBody = other.querySelector('[data-fby-clean-body]');
            if (otherBody) otherBody.hidden = true;
            var otherChev = other.querySelector('[data-fby-clean-chev]');
            if (otherChev) otherChev.textContent = '⌄';
          });
          if (isOpen){
            card.classList.remove('fby-clean-open');
            bodyEl.hidden = true;
            if (chev) chev.textContent = '⌄';
          } else {
            card.classList.add('fby-clean-open');
            bodyEl.hidden = false;
            if (chev) chev.textContent = '⌃';
            if (!loadedHandles[handle]){
              loadedHandles[handle] = true;
              renderCleanCategoryBody(handle, bodyEl);
            }
          }
        });
      });
    }

    wireCleanAccordion();
  }

  function boot(){
    document.querySelectorAll('[data-fby-ymm-root]').forEach(initSection);
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
